import { CurrencyPipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { config, inspectionItemColorIndex, paymentTypeTitle, serviceAuthConsts, workStateTitle } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { itemTypeLabel } from 'app/constants/itemType.constants';
import { followUpEvents } from 'app/constants/marketing.constants';

import { CalculationService } from 'app/services/calculation.service';
import { DateService } from 'app/services/date.service';
import { HelperService } from 'app/services/helper.service';

import { activityTypeSupplierOrder, activityTypeSupplierOrderSublet } from 'app/constants/csv/constants';
import { currency } from 'app/constants/currency.constants';
import { OrderStateType } from 'app/constants/orders.constants';
import { find, findIndex, orderBy, sum } from 'lodash';
import * as moment from 'moment';
import { DataService } from './data.service';
// import * as XLSX from 'xlsx';

@Injectable()
export class FormatService {
  featureIsPayRixEnable: boolean = false;
  tireSeason = {
    all: 'All seasons',
    summer: 'Summer',
    winter: 'Winter',
    allWeather: 'All weather',
  };

  defaultCount = {
    categories: 0,
    items: 0,
    condition: {
      good: 0,
      normal: 0,
      bad: 0,
      notInspected: 0,
    },
    images: 0,
    audios: 0,
  };
  counts = this.helperService.deepCopy(this.defaultCount);
  categoryItemText: string = '';
  itemTypeLabel = { ...itemTypeLabel };
  serviceStatusLabel = {
    pending: 'Pending',
    approved: 'Approved',
    deferred: 'Deferred',
    declined: 'Declined',
    archived: 'Archived',
    deferredLocked: 'Deferred locked',
  };
  serviceStatusLabelFR = {
    pending: 'En attente',
    approved: 'Approuvé',
    deferred: 'Différé',
    declined: 'Refusé',
    archived: 'Archivé',
    deferredLocked: 'Différé verrouillé',
  };
  orderingMethodsValue = {
    online: 'Online',
    offline: 'Offline',
    provisional: 'Provisional',
    inventory: 'Inventory',
  };
  orderingStatusValue = {
    unordered: 'draft',
    ordered: 'ordered',
    delivered: 'received',
    cancelled: 'cancelled',
  };

  finalizeTypeLabel = {
    fullyPaid: 'Fully Paid',
    thirdPartyAccounts: '3rd party -',
    accountsReceivable: 'Account Receivable',
  };

  constructor(
    private currencyPipe: CurrencyPipe,
    private helperService: HelperService,
    private dateService: DateService,
    private dataService: DataService,
    private calculationService: CalculationService,
  ) {}

  getLocalAndOtherLocations(localTires: any, invItemId?: string): any {
    const localLocations: any[] = [];
    const otherLocations: any[] = [];

    if (localTires?.length) {
      localTires.forEach((tireInv: any) => {
        if (tireInv?.locations?.length) {
          if (this.helperService.getCompany().isMultiLocationEnabled) {
            tireInv.locations.forEach((location: any) => {
              if (location?.stocked) {
                const obj = find(tireInv?.stockDetails, { warehouseId: location?.warehouseId });
                if (obj) {
                  tireInv.source = 'autoleap';
                  const locationObj = {
                    warehouseId: obj.warehouseId,
                    name: location.name,
                    leadTime: '',
                    estimatedDeliveryDay: '',
                    totalAvailable: obj?.countAvailable || 0,
                    itemId: invItemId,
                    count: 0,
                    cost: obj?.averageCost || tireInv?.cost || 0,
                    inventoryTireData: tireInv,
                    locationId: location?.locationId,
                  };
                  //tireInv.cost = obj?.averageCost || 0;
                  const index = findIndex(localLocations, { locationId: location?.locationId, warehouseId: location.warehouseId });
                  if (location.warehouseId === this.dataService.warehouse?.warehouseId) {
                    if (index < 0) {
                      if (tireInv?.costType === 'latestPo') {
                        locationObj.cost = obj?.latestPoCost || tireInv?.cost || 0;
                      } else if (tireInv?.costType === 'avg') {
                        locationObj.cost = obj?.averageCost || tireInv?.cost || 0;
                      } else if (tireInv?.costType === 'cost') {
                        locationObj.cost = tireInv?.cost;
                      }
                      localLocations.push(locationObj);
                    }
                  } else {
                    if (index < 0) {
                      if (tireInv?.costType === 'latestPo') {
                        locationObj.cost = obj?.latestPoCost || tireInv?.cost || 0;
                      } else if (tireInv?.costType === 'avg') {
                        locationObj.cost = obj?.averageCost || tireInv?.cost || 0;
                      } else if (tireInv?.costType === 'cost') {
                        locationObj.cost = tireInv?.cost;
                      }
                      otherLocations.push(locationObj);
                    }
                  }
                }
              }
            });
          } else {
            const locationObj = {
              warehouseId: tireInv.locations[0].warehouseId,
              name: tireInv.locations[0].name,
              leadTime: '',
              estimatedDeliveryDay: '',
              totalAvailable: tireInv?.countAvailable || 0,
              itemId: invItemId,
              count: 0,
              cost: tireInv?.averageCost || tireInv?.cost || 0,
              inventoryTireData: tireInv,
            };
            if (tireInv?.costType === 'latestPo') {
              locationObj.cost = tireInv?.latestPoCost || tireInv?.cost || 0;
            } else if (tireInv?.costType === 'avg') {
              locationObj.cost = tireInv?.averageCost || tireInv?.cost || 0;
            } else if (tireInv?.costType === 'cost') {
              locationObj.cost = tireInv?.cost;
            }
            localLocations.push(locationObj);
          }
        }
      });
    }

    return { localLocations, otherLocations };
  }

  getLocalAndOtherForALInvCount(tire: any): any {
    let localAvailable: number = 0;
    let otherAvailable: number = 0;
    let stockCountAvailable: number = 0;
    if (tire?.stockDetails?.length) {
      tire?.stockDetails?.forEach((stock: any) => {
        if (this.helperService.getCompany().isMultiLocationEnabled) {
          if (stock.warehouseId === this.dataService.warehouse.warehouseId) {
            localAvailable += stock.countAvailable || 0;
            stockCountAvailable += stock.countAvailable || 0;
          } else {
            otherAvailable += stock.countAvailable || 0;
            stockCountAvailable += stock.countAvailable || 0;
          }
        } else {
          localAvailable += stock.countAvailable || 0;
          stockCountAvailable += stock.countAvailable || 0;
        }
      });
    } else {
      localAvailable += tire.countAvailable || 0;
      stockCountAvailable += tire.countAvailable || 0;
    }

    return { localAvailable, otherAvailable, stockCountAvailable };
  }

  getLocalAndOtherInvCount(localTires: any[]): any {
    let localAvailable: number = 0;
    let otherAvailable: number = 0;
    let localFetValue: number = 0;
    if (localTires?.length) {
      localTires.forEach((tireInv: any) => {
        if (tireInv?.stockDetails?.length) {
          tireInv.stockDetails?.forEach((stock: any) => {
            if (this.helperService.getCompany().isMultiLocationEnabled) {
              if (stock.warehouseId === this.dataService.warehouse.warehouseId) {
                localAvailable += stock.countAvailable || 0;
              } else {
                otherAvailable += stock.countAvailable || 0;
              }
            } else {
              localAvailable += stock.countAvailable;
            }
          });
        }
      });
      localFetValue = localTires[0]?.fetValue || 0;
    }

    return { localAvailable, otherAvailable, localFetValue };
  }

  formatFleetSettings(settings: any) {
    const fleetSettings: any = {
      isOrderDiscOverride: settings.isOrderDiscOverride,
      isShopSuppliesOverride: settings.isShopSuppliesOverride,
      isLaborRateOverride: settings.isLaborRateOverride,
      isPricingMatrixOverride: settings.isPricingMatrixOverride,
      isTaxCodeOverride: settings.isTaxCodeOverride,
      isPartPricingMatrixOverride: settings.isPartPricingMatrixOverride,
      isTirePricingMatrixOverride: settings.isTirePricingMatrixOverride,
      useDriverDetailOnInvoice: settings.useDriverDetailOnInvoice,

      customTaxCode: null,
      customLaborRate: null,
      customPartPricingMatrix: null,
      customTirePricingMatrix: null,
      customOrderDiscount: null,
      customShopSupplies: null,
    };

    if (fleetSettings.isOrderDiscOverride) {
      fleetSettings.customOrderDiscount = {
        value: settings.customOrderDiscountValue,
        type: settings.customOrderDiscountType.value,
        cap: settings.customOrderDiscountCap,
      };
    }

    if (fleetSettings.isShopSuppliesOverride) {
      fleetSettings.customShopSupplies = {
        value: settings.customShopSuppliesValue,
        type: settings.customShopSuppliesType.value,
        cap: settings.customShopSuppliesCap,
      };
    }

    if (fleetSettings.isLaborRateOverride) {
      fleetSettings.customLaborRate = (settings.customLaborRate && settings.customLaborRate._id) || null;
    }

    if (fleetSettings.isPricingMatrixOverride) {
      fleetSettings.customPartPricingMatrix = (settings.customPartPricingMatrix && settings.customPartPricingMatrix._id) || null;
    }

    if (fleetSettings.isTaxCodeOverride) {
      fleetSettings.customTaxCode = (settings.customTaxCode && settings.customTaxCode._id) || null;
    }

    // advance pricing
    if (fleetSettings.isPartPricingMatrixOverride && settings?.customPartPricingMatrix?.hasOwnProperty('_id')) {
      fleetSettings.customPartPricingMatrix = {
        name: settings?.customPartPricingMatrix?.name,
        type: settings?.customPartPricingMatrix?.type,
        _id: settings?.customPartPricingMatrix?._id,
      };
    }

    if (fleetSettings.isTirePricingMatrixOverride && settings?.customTirePricingMatrix?.hasOwnProperty('_id')) {
      fleetSettings.customTirePricingMatrix = {
        name: settings?.customTirePricingMatrix?.name,
        type: settings?.customTirePricingMatrix?.type,
        _id: settings?.customTirePricingMatrix?._id,
      };
    }

    return fleetSettings;
  }

  formatRevenueRecognitionAppliedFilter(finalizeType: any[], event: any) {
    const thirdPartyAccountList = [];
    const finalizeTypeList = [];
    //const filter = this.helperService.deepCopy(event);

    if (finalizeType?.length) {
      finalizeType.forEach((item: any) => {
        if (['notFinalized', 'fullyPaid', 'accountsReceivable'].includes(item.key)) {
          finalizeTypeList.push(item.key);
        } else {
          thirdPartyAccountList.push(item.key);
        }
      });
    }

    event.finalizeType = finalizeTypeList;
    event.thirdPartyAccount = thirdPartyAccountList;

    //console.log(filter.finalizeType, filter.thirdPartyAccount);
    //console.log(this.helperService.deepCopy(filter));
    return event;
  }

  formatFinalaizeRoType(finalizeRoType: any[], event: any) {
    let roTypeArray: any[] = [];
    let thirdPartyAccountList = [];
    // if (finalizeRoType?.length) {
    //   finalizeRoType.forEach((roType: any) => {
    //     roTypeArray.push(roType.key);
    //   });
    // } else {
    //   roTypeArray.push('all');
    // }

    // if (roTypeArray?.length === 2) {
    //   roTypeArray = [];
    //   roTypeArray.push('all');
    // }
    if (finalizeRoType?.length) {
      finalizeRoType.forEach((item: any) => {
        if (item.key === 'nonThirdParty') {
          roTypeArray.push(item.key);
        } else {
          thirdPartyAccountList.push(item.key);
        }
      });
    }

    event.finalizeRoType = roTypeArray;
    event.thirdPartyRoType = thirdPartyAccountList;
  }

  formatTransferOrderListData(records: any[]) {
    return records.map((data: any) => {
      const fields: any = {
        avgCost: data?.avgCost || '',
        code: data?.code || '',
        dateApproved: data.dateApproved ? this.dateService.getCurrentDateTimeTz(new Date(data.dateApproved).getTime()) : '',
        dateCancelled: data.dateCancelled ? this.dateService.getCurrentDateTimeTz(new Date(data.dateCancelled).getTime()) : '',
        dateRequested: data.dateRequested ? this.dateService.getCurrentDateTimeTz(new Date(data.dateRequested).getTime()) : '',
        itemName: data?.itemName || '',
        itemNumber: data?.itemNumber || '',
        itemId: data?.itemId || '',
        qty: data?.qty,
        senderWarehouseName: data?.senderWarehouse?.name || '',
        receiverWarehouseName: data?.receiverWarehouse?.name || '',
        status: data?.status || '',
        totalCost: data?.totalCost,
        type: data?.type,
        moduleId: data?.moduleId,
      };
      return fields;
    });
  }

  formatCustomReportData(data: any[]): any[] {
    let filterData: any[] = [];
    if (data && data.length) {
      data.forEach((item: any) => {
        filterData.push({
          name: item.reportName,
          link: 'reports/custom-reporting',
          iFrameUrl:item.iFrameUrl,
        });
      });
    }
    return filterData;
  }

  formatRevenueRecognitionFilterData(data: any[]): any[] {
    let filterData: any[] = [];
    if (data && data.length) {
      const header = { name: '3rd Party', isHeader: true, nameSort: 'thirdparty', key: 'thirdparty', value: 'thirdparty' };
      filterData.push(header);
      data.forEach((item: any) => {
        filterData.push({
          name: item.name,
          isHeader: false,
          nameSort: 'thirdparty',
          key: item._id,
          value: 'thirdparty',
        });
      });
    }
    return filterData;
  }

  formatFleetList(records: any[]): any[] {
    const shopsMap = this.dataService.shopsMap;
    return records.map((data: any) => {
      const { _id, statementName, paymentDate, customer, invoicesTotal, amount, shopId } = data;
      const fields = {
        location: shopsMap[shopId] && shopsMap[shopId].shopName,
        paymentDate: this.helperService.dateFormatMMMDDYY(paymentDate) ? this.helperService.dateFormatMMMDDYY(paymentDate) : '-',
        statementName: statementName ? statementName : '-',
        isFleetCustomer: customer.isFleetCustomer ? 'Fleet' : 'Regular',
        paymentMethod: this.getPaymentType(this.featureIsPayRixEnable, data),
        customer: customer.displayName || customer.fullName ? customer.displayName || customer.fullName : '-',
        total: invoicesTotal ? invoicesTotal.toFixed(2) : '0.00',
        paid: amount ? amount.toFixed(2) : '0.00',
        _id: _id,
      };

      return fields;
    });
  }

  formatRegularList(records: any[]): any[] {
    const shopsMap = this.dataService.shopsMap;
    return records.map((data) => {
      const { paymentDate, roNumber, invoiceCode, customer, totalInvoiceAmount, amount, shopId, orderId } = data;
      const fields = {
        location: shopsMap[shopId] && shopsMap[shopId].shopName,
        paymentDate: this.helperService.dateFormatMMMDDYY(paymentDate) ? this.helperService.dateFormatMMMDDYY(paymentDate) : '-',
        invoiceCode: invoiceCode,
        roNumber: roNumber,
        isFleetCustomer: customer.isFleetCustomer ? 'Fleet' : 'Regular',
        paymentMethod: this.getPaymentType(this.featureIsPayRixEnable, data).replace('creditPayment', 'credit payment'),
        customer: customer.displayName || customer.fullName ? customer.displayName || customer.fullName : '-',
        total: totalInvoiceAmount ? totalInvoiceAmount.toFixed(2) : '0.00',
        paid: amount ? amount.toFixed(2) : '0.00',
        orderId: orderId,
      };

      return fields;
    });
  }

  customerListFormat(customers: any[]) {
    return customers.map((customer: any) => {
      let unSubscribedContacts = 0;

      if (customer.emailPreference && customer.phonePreference) {
        // subscribedContacts = customer.emailPreference.subscribed + customer.phonePreference.subscribed;
        unSubscribedContacts = customer.emailPreference.unsubscribed + customer.phonePreference.unsubscribed;
      }

      let emailCount = 0,
        phoneCount = 0;

      if (customer.contact && customer.contact[0] && customer.contact[0].contactInfo)
        for (let index = 0; index < customer.contact[0].contactInfo.length; index++) {
          const contact = customer.contact[0].contactInfo[index];

          if (contact.contactType === 'email') {
            emailCount += 1;
          } else {
            phoneCount += 1;
          }
        }

      const vehicleLength = (customer.vehicles && customer.vehicles.length) || 0;
      const phone = this.formatPhoneNumber(customer.phone && customer.phone.toString());
      // const phone2 = this.formatPhoneNumber(customer.phone2);

      const _customer = {
        _id: customer._id,
        preferredLanguage: customer.preferredLanguage || 'EN',
        isChecked: false,
        fullName: customer.fullNameQBO,
        phone: `${phone || ''}`,
        email: `${customer.email || ''}`,
        tags: customer.tags,
        companyName: customer.companyName || '',
        customerType: customer.customerType || '',
        vehicle: vehicleLength ? `${customer.vehicles.pop().name}${vehicleLength > 1 ? ', ...' : ''}` : '',
        vehicleCount: customer.vehicleCount || vehicleLength,
        createdAt: this.dateService.getCurrentDateTimeTz(new Date(customer.createdAt).getTime()),
        lastInvoiceDate: customer.lastInvoiceDate ? this.dateService.getCurrentDateTimeTz(new Date(customer.lastInvoiceDate).getTime()) : '',
        lastROCreateDate: customer.lastROCreateDate ? this.dateService.getCurrentDateTimeTz(new Date(customer.lastROCreateDate).getTime()) : '',
        roCount: customer.roCount || 0,
        invoiceCount: customer.invoiceCount || 0,
        totalSales: customer.totalSales || 0,
        totalProfit: this.calculationService.roundOff(customer.totalProfit || 0),
        deferredServiceCount: customer.deferredServiceCount || 0,
        totalPayments: customer.totalPayments || 0,
        outstandingBalance: customer.outstandingBalance || 0,
        isUnsubscribed: unSubscribedContacts,
        ...(() => {
          const messageStatusObj = {
            marketingMessageStatus: '',
            marketingMessageFailReason: '',
          };

          if (!customer.marketingCampaignActivity) {
            return '';
          } else if (customer.marketingCampaignActivity.isProcessed && !customer.marketingCampaignActivity.isSent) {
            messageStatusObj.marketingMessageStatus = 'Failed';
            messageStatusObj.marketingMessageFailReason = 'Message failed due to invalid number';
          } else if (['QUEUED_INTERNALLY', 'SENT_INTERNALLY', 'SERVICE_ACCEPTED', 'SERVICE_QUEUED', 'SERVICE_SENDING'].includes(customer.marketingCampaignActivity.chatMessageStatus)) {
            messageStatusObj.marketingMessageStatus = 'In Progress';
          } else if (['SERVICE_FAILED', 'UNDELIVERED'].includes(customer.marketingCampaignActivity.chatMessageStatus)) {
            messageStatusObj.marketingMessageStatus = 'Undelivered';
          } else if ('DELIVERED' === customer.marketingCampaignActivity.chatMessageStatus) {
            messageStatusObj.marketingMessageStatus = 'Delivered';
          } else if (!customer.marketingCampaignActivity.isSent) {
            messageStatusObj.marketingMessageStatus = 'Pending';
          } else {
            messageStatusObj.marketingMessageStatus = 'Sent';
          }
          // if ('SERVICE_SENT' === customer.marketingCampaignActivity.chatMessageStatus) return 'Sent';
          // return 'Sent';
          return messageStatusObj;
        })(),
      };

      return _customer;
    });
  }

  inventortyListFormat(inventoryLevel: any[]) {
    return inventoryLevel.map(
      ({
        type,
        itemId,
        location,
        itemName,
        code,
        averageCost,
        countInHand,
        warehouseId,
        countOrdered,
        restockLevel,
        countAvailable,
        countTransit,
        itemDetailTitle,
        itemDescription,
        countOnEstimate,
        itemDetailDescription,
        itemDetailRestockLevel,
        description
      }) => {
        return {
          warehouseId,
          itemId: itemId,
          itemType: type || '',
          type,
          averageCost: averageCost || 0,
          countInHand: countInHand || 0,
          countOrdered: countOrdered || 0,
          countAvailable: countAvailable || 0,
          countOnEstimate: countOnEstimate || 0,
          countTransit: countTransit || 0,
          itemName: (itemDetailTitle || itemName || '').replace(/"/g, '""'),
          code: code || '',
          location: (location && location.name) || '',
          stockValue: this.calculationService.roundOff(countAvailable * averageCost),
          stockInTransitValue: this.calculationService.roundOff(countTransit * averageCost),
          stockOnHand: this.calculationService.roundOff(countInHand * averageCost),
          stockOnEstimate: this.calculationService.roundOff(countOnEstimate * averageCost),
          restockLevel: itemDetailRestockLevel || restockLevel || 0,
          description: itemDetailDescription || itemDescription || description || '',
        };
      },
    );
  }

  purchaseOrderListFormat(purchaseOrders: any[]) {
    return purchaseOrders.map(({ code, pOStartDateTime, supplier, items, total }) => {
      const titles = [];
      let totalCount = 0;

      items.forEach(({ count = 0, title }) => {
        titles.push(title);
        totalCount += count;
      });

      return {
        code,
        dateOrdered: pOStartDateTime ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(pOStartDateTime).getTime()), datetimeFormat.mmmdyyyy) : '',
        supplier: (supplier && supplier.name) || '',
        items: titles.join(', '),
        count: totalCount,
        total: (total && total.grand) || 0,
      };
    });
  }

  categoriesListFormat(services: any[]) {
    return services.map(({ name, subSubCategory, source, subCategory, category, _id, itemType, pricing }) => ({
      id: _id,
      name: [category, subCategory, subSubCategory].filter((str) => str).pop(),
      type: `Item: ${this.helperService.textCapitalize(itemType) || ''}`,
      source: source,
      category: category,
      itemType,
      subcategory: subCategory,
      subsubcategory: subSubCategory,
      fullName: [category, subCategory, subSubCategory].filter((str) => str).join(' : '),
      pricing: pricing,
    }));
  }

  servicesListFormat(services: any[]) {
    return services.map(({ _id, title, titleFR, status, category, serviceTotal, items }) => ({
      _id,
      title,
      titleFR,
      category: category ? category.name : '',
      status: status ? 'Active' : 'Inactive',
      parts: serviceTotal ? serviceTotal.part : 0,
      labor: serviceTotal ? serviceTotal.labor : 0,
      tire: serviceTotal ? serviceTotal.tire : 0,
      other: serviceTotal ? serviceTotal.other : 0,
      hazmatFee: serviceTotal ? serviceTotal.hazmatFee : 0,
      items: items ? items.length : 0,
      price: serviceTotal ? serviceTotal.total : 0,
      //cost: serviceTotal ? serviceTotal.cost : 0,
      cost: this.calculateCannedCostTotal(items),
    }));
  }
  //  Fixation of ALP-10014
  calculateCannedCostTotal(items: any[]) {
    let totalCost: number = 0;
    if (items && items.length > 0) {
      items.map((item: any) => {
        // NOTE! Not able to understand why this costRate key is added here! For now added a 0 condition if key not found the total was changed to NAN

        // Note:- The cost is already being calculated from BE (Backend), so we don't need to use the above code.
        // totalCost = totalCost + (item.type === 'labor' ? (item.cost || item.costRate || 0)  * item.count : item.cost * item.count);
        totalCost = totalCost + (item.cost || item.costRate || 0);
      });
    }
    return totalCost;
  }

  formatOrderService(services: any[]) {
    return services.map(({ roCode, customerId, estimateId, serviceStatus, serviceTitle, isFleetCustomer, customerName, roInvoiceDate, roCreatedDate, serviceCategory }) => {
      if (roCreatedDate) {
        roCreatedDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(roCreatedDate).getTime()), datetimeFormat.mmmdyyyy);
      }

      if (roInvoiceDate) {
        roInvoiceDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(roInvoiceDate).getTime()), datetimeFormat.mmmdyyyy);
      }

      if (serviceCategory && serviceCategory.name) {
        serviceCategory = serviceCategory.name;
      }

      return {
        roCode,
        customerId,
        estimateId,
        serviceType: this.serviceStatusLabel[serviceStatus] || this.serviceStatusLabel.pending,
        serviceTitle,
        customerType: isFleetCustomer ? 'Fleet' : 'Regular',
        customerName,
        roInvoiceDate,
        roCreatedDate,
        serviceCategory,
      };
    });
  }

  formatMarketingGroup(data: any[]) {
    return data.map(({ _id, type, createdAt, title, noOfEmails, noOfPhones, description, noOfCustomers, filters = {} }) => {
      const filtersText = [];
      const group = {
        _id,
        type,
        title,
        noOfEmails,
        noOfPhones,
        description,
        noOfCustomers,
        createdAt,
        filtersDescription: '',
      };

      if (type === 'CUSTOMER' && filters.tags && filters.tags.selected) {
        if (filters.tags.selected.length) {
          filtersText.push(`Tags: ${filters.tags.selected.map(({ name }) => name).join(', ')}`);
        } else {
          filtersText.push(`Tags: All`);
        }
      }

      if (type === 'DEFERRED' && filters.serviceCategories && filters.serviceCategories.selected) {
        if (filters.serviceCategories.selected.length) {
          filtersText.push(`Service categories: ${filters.serviceCategories.selected.map(({ name }) => name).join(', ')}`);
        } else {
          filtersText.push(`Service categories: All`);
        }
      }

      if (type === 'DEFERRED' && filters.serviceAuthStatus && filters.serviceAuthStatus.selected) {
        if (filters.serviceAuthStatus.selected.length) {
          filtersText.push(`Authorization status: ${filters.serviceAuthStatus.selected.map(({ name }) => name).join(', ')}`);
        } else {
          filtersText.push(`Authorization status: All`);
        }
      }

      if (type === 'DEFERRED' && filters.searchTerms && filters.searchTerms.selected) {
        if (filters.searchTerms.selected.length) {
          filtersText.push(`Search terms: ${filters.searchTerms.selected.map(({ name }) => name).join(', ')}`);
        } else {
          filtersText.push(`Authorization status: All`);
        }
      }

      if (type === 'DEFERRED' && filters.customerFleet) {
        filtersText.push(`Customer type: ${filters.customerFleet.regular === filters.customerFleet.fleet ? 'All' : filters.customerFleet.fleet ? 'Fleet' : 'Regular'}`);
      }

      if (type === 'CUSTOMER' && filters.status) {
        filtersText.push(`Customer type: ${filters.status.active === filters.status.inActive ? 'All' : filters.status.active ? 'Active' : 'Inactive'}`);
      }

      if (type === 'CUSTOMER' && (filters.preferredLanguage?.en || filters.preferredLanguage?.fr)) {
        const languages = [];

        if (filters.preferredLanguage?.en) {
          languages.push('English');
        }

        if (filters.preferredLanguage?.fr) {
          languages.push('French');
        }

        if (languages.length) {
          filtersText.push(`Languages: ${languages.map((name) => name).join(', ')}`);
        }
      }

      if (filters.date && filters.date.startDate && filters.date.endDate) {
        const { startDate, endDate } = filters.date;

        filtersText.push(
          `Invoice date: ${this.dateService.formatDate(new Date(`${startDate} 00:00`), datetimeFormat.mmmdyyyy)} - ${this.dateService.formatDate(
            new Date(`${endDate} 00:00`),
            datetimeFormat.mmmdyyyy,
          )}`,
        );
      }

      if (type === 'DEFERRED' && filters.roCreateAtFilterOption && filters.roCreateAtFilterOption.startDate && filters.roCreateAtFilterOption.endDate) {
        const { startDate, endDate } = filters.roCreateAtFilterOption;

        filtersText.push(
          `Created date: ${this.dateService.formatDate(new Date(`${startDate} 00:00`), datetimeFormat.mmmdyyyy)} - ${this.dateService.formatDate(
            new Date(`${endDate} 00:00`),
            datetimeFormat.mmmdyyyy,
          )}`,
        );
      }

      group.filtersDescription = filtersText.join(' - ');
      group.createdAt = createdAt;
      return group;
    });
  }

  formatFollowUpCampaignList(data: any[]) {
    const smartFilters = {
      SEND_ESTIMATE: {
        serviceName: true,
        serviceAuthStatus: true,
        serviceCategories: false,
        roCreateAtFilterOption: true,
        authorization: false,
        customerFleet: false,
        invoiceDateFilterOption: false,
      },
      RO_INVOICED: {
        serviceName: true,
        serviceAuthStatus: true,
        serviceCategories: false,
        roCreateAtFilterOption: true,
        customerFleet: false,
        invoiceDateFilterOption: true,
      },
      //Service name, Categories, RO created date, RO Invoice date, Authorization status
      RO_FULL_PAID: {
        serviceName: true,
        serviceAuthStatus: true,
        serviceCategories: false,
        roCreateAtFilterOption: true,
        customerFleet: false,
        invoiceDateFilterOption: true,
      },
      // Customer tags, RO Invoice date, Active/Inactive
      CUSTOMER_SAVE: {
        serviceName: false,
        serviceAuthStatus: false,
        serviceCategories: false,
        roCreateAtFilterOption: false,
        authorization: false,
        customerFleet: false,
        tags: true,
        invoiceDateFilterOption: true,
        status: true,
      },
      // Customer tags, Vehicle tags, RO Invoice date, Active/Inactive
      VEHICLE_SAVE: {
        serviceName: false,
        serviceAuthStatus: false,
        serviceCategories: false,
        roCreateAtFilterOption: false,
        authorization: false,
        customerFleet: false,
        tags: true,
        vehicleTags: true,
        invoiceDateFilterOption: true,
        status: true,
      },
    };
    return data.map((campaign) => {
      const filtersText = [];
      const filters = campaign.filters;

      const smartFilter = smartFilters[campaign.followUpEvent];

      if (smartFilter && filters) {
        if (smartFilter.tags && filters.tags && filters.tags.selected) {
          if (filters.tags.selected.length) {
            filtersText.push(`Customer tags: ${filters.tags.selected.map(({ name }) => name).join(', ')}`);
          } else {
            filtersText.push(`Customer tags: All`);
          }
        }

        if (smartFilter.vehicleTags && filters.vehicleTags && filters.vehicleTags.selected) {
          if (filters.vehicleTags.selected.length) {
            filtersText.push(`Vehicle: ${filters.vehicleTags.selected.map(({ name }) => name).join(', ')}`);
          } else {
            filtersText.push(`Vehicle: All`);
          }
        }

        if (smartFilter.serviceCategories && filters.serviceCategories && filters.serviceCategories.selected) {
          if (filters.serviceCategories.selected.length) {
            filtersText.push(`Service categories: ${filters.serviceCategories.selected.map(({ name }) => name).join(', ')}`);
          } else {
            filtersText.push(`Service categories: All`);
          }
        }

        if (smartFilter.serviceAuthStatus && filters.serviceAuthStatus && filters.serviceAuthStatus.selected) {
          if (filters.serviceAuthStatus.selected.length) {
            filtersText.push(`Authorization status: ${filters.serviceAuthStatus.selected.map(({ name }) => name).join(', ')}`);
          } else {
            filtersText.push(`Authorization status: All`);
          }
        }

        if (smartFilter.serviceName && filters.searchTerms && filters.searchTerms.selected) {
          if (filters.searchTerms.selected.length) {
            filtersText.push(`Search terms: ${filters.searchTerms.selected.join(', ')}`);
          } else {
            filtersText.push(`Search term: All`);
          }
        }
      }

      campaign.filtersDescription = filtersText.join(' - ');
      return campaign;
    });
  }

  formatFollowUpList(data: any[], payload: any = {}) {
    return data.map((campaign) => {
      // status contact sendDate customer vehicle orderCode isSend appointmentStatus orderState template
      const followUp = {
        status: campaign.isSend ? 'Past' : 'Upcoming',
        contact: '',
        customer: campaign.customer,
        sendDate: campaign.isSend ? this.dateService.getCurrentDateTimeTz(new Date(campaign.sendDate).getTime()) : '',
        vehicle: campaign.vehicle && campaign.vehicle.name,
        orderCode: campaign.order && campaign.order.code,
        isSend: campaign.isSend ? 'Sent' : 'Not sent',
        appointmentStatus: '',
        orderState: '',
        isUnsubscribed: false,
        marketingTemplate: campaign.marketingTemplate,
        template: campaign.marketingTemplate.text,
        sentTooltip: '',
        isFollowUpSent: campaign.isSend,
      };

      if (campaign.contact && campaign.contact.contactInfo && campaign.contact.contactInfo.length) {
        const contactType = campaign.type === 'EMAIL' ? 'email' : 'mobile';
        campaign.contact.contactInfo = campaign.contact.contactInfo.filter(({ isActive }) => isActive);

        if (payload.isSendToPrimaryOnly) {
          const primary = find(campaign.contact.contactInfo, { contactType: contactType, isPrimary: true });

          if (primary && primary.value && primary.isMarketingNotifEnabled === false) {
            followUp.isUnsubscribed = true;
          }
        } else {
          followUp.isUnsubscribed = campaign.contact.contactInfo.length === campaign.contact.contactInfo.filter(({ isMarketingNotifEnabled }) => isMarketingNotifEnabled === false).length;
        }
      }

      if (campaign.sentToContacts && campaign.sentToContacts.length) {
        followUp.sentTooltip = `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
          ${campaign.type === 'EMAIL' ? 'Email' : 'SMS'}
          </div>

          ${(campaign.sentToContacts || []).map(
            ({ isSent, contactType, value }) =>
              `<div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
                <i class="fal fa-${isSent ? 'check' : 'times'} ${isSent ? 'font-primary' : 'font-red'} mt-1 pr-2"></i>
                <span>${value}</span>
              </div>`,
          )}
        </div>
      `;
      }

      if (campaign.isSend && campaign.sentToContacts && campaign.sentToContacts.length) {
        followUp.isSend = campaign.sentToContacts.filter(({ isSent }) => isSent).length > 0 ? 'Sent' : 'Not sent';
      }

      if (campaign.order && campaign.order[0] && campaign.order[0].orderStatus) {
        followUp.orderState = campaign.order[0].orderStatus === 'invoice' ? 'Invoiced' : 'Estimate';
      }

      if (campaign.appointment && campaign.appointment[0] && campaign.appointment[0].status) {
        followUp.orderState = campaign.appointment[0].status;
      }

      return followUp;
    });
  }

  formatServiceHistory(history: any[]) {
    history.forEach((history: any) => {
      if (history.method === 'autoAuthorized') {
        history.methodText = 'Auto authorized';
      }
      if (history.method === 'autoDeferred') {
        history.methodText = 'Auto deferred';
      } else if (history.method === 'autoDeclined') {
        history.methodText = 'Declined by Officer user';
      } else if (history.method === 'online') {
        history.methodText = `${this.serviceStatusLabel[history.status]} online`;
      } else if (['inPerson', 'phone', 'sms', 'email'].includes(history.method)) {
        history.methodText = `${this.serviceStatusLabel[history.status]} via ${history.method === 'inPerson' ? 'in person' : history.method}`;
      }
      history.createdAt = this.dateService.getCurrentDateTimeTz(new Date(history.createdAt).getTime());
    });

    return history.reverse();
  }

  partsListFormat(parts: any[], isFromListSelection = false) {
    return parts.map((part: any) => ({
      ...part,
      _id: part._id,
      code: part.code,
      title: part.title,
      category: isFromListSelection ? part?.category || '' : part.category ? part.category.name : '',
      supplier: isFromListSelection ? part?.supplier || '' : part.supplier ? part.supplier.name : '',
      salesCode: this.displaySalesCodeTitle(part),
      salesCodeShortName: part?.salesCode?.shortName || '',
      cost: this.setDynamicCostAndPrice(part, 'cost'),
      price: this.setDynamicCostAndPrice(part, 'price'),
      isTaxable: part.isTaxable,
      status: part.status,
      stocked: part.stocked,
      isWarrantyEligible: part?.isWarrantyEligible || false,
    }));
  }

  displaySalesCodeTitle(data: any) {
    if (data?.salesCode?.salesCodeId) {
      if (data?.salesCode?.title && data?.salesCode?.shortName) {
        return `${data.salesCode.title} (${data.salesCode.shortName})`;
      }
      return data?.salesCode?.title;
    } else if (data.category?.categoryId) {
      return 'Unassigned';
    } else {
      return '';
    }
  }

  setDynamicCostAndPrice(item, value) {
    if (!['part', 'tire'].includes(item.type)) return item[value];

    const shopDetails = Array.isArray(item?.shopDetails) ? item?.shopDetails : [item?.shopDetails];
    const stockDetails = Array.isArray(item?.stockDetails) ? item?.stockDetails : [item?.stockDetails];

    if (value === 'cost') {
      if (item.costType) {
        if (this.helperService.getCompany().isMultiLocationEnabled) {
          if (item.locations && item.locations.length > 0) {
            item?.locations.forEach((location: any) => {
              if (location?.stocked) {
                const obj = find(stockDetails, { warehouseId: location?.warehouseId });
                if (obj && this.dataService.warehouse.warehouseId === obj.warehouseId) {
                  item.cost = item.costType === 'latestPo' ? obj.latestPoCost : item.costType === 'avg' ? obj.averageCost : item.cost;
                }
              }
            });
          }
        } else {
          item.cost = item.costType === 'latestPo' ? item.latestPoCost : item.costType === 'avg' ? item.averageCost : item.cost;
        }
      }
      return item.cost || 0;
    } else {
      const obj = find(shopDetails, { shopId: this.helperService.getCurrentShopId() });
      if (obj) {
        item.price = obj?.price || item.price;
      }
      return item.price || 0;
    }
  }

  tireListFormat(tires: any[]) {
    return tires.map((tire) => ({
      ...tire,
      _id: tire._id,
      title: tire.title,
      brand: tire.brand || '',
      model: tire.model || '',
      salesCode: this.displaySalesCodeTitle(tire),
      salesCodeShortName: tire?.salesCode?.shortName || '',
      category: tire.category ? tire.category.name : '',
      seasonality: this.tireSeason[tire.seasonality] || '',
      vendor: (tire.supplier && tire.supplier.name) || '',
      size: tire.size || '',
      status: tire.status,
      partNumber: tire.code || '',
      cost: this.setDynamicCostAndPrice(tire, 'cost'),
      price: this.setDynamicCostAndPrice(tire, 'price'),
      stocked: tire.stocked,
      isWarrantyEligible: tire.isWarrantyEligible,
    }));
  }

  supplierListFormat(suppliers: any[]) {
    return suppliers.map((supplier) => ({
      _id: supplier._id,
      supplierName: supplier.name,
      archive: supplier.archive ? true : false,
      type: `${(supplier.type === 'QBO' ? 'Internal' : supplier.type) || ''}`,
      createdAt: supplier.createdAt || '',
      accountNumber: supplier.accountNumber || '',
      url: supplier.url || '',
      emails:
        supplier.contacts &&
        supplier.contacts.contactInfo.map((email) => {
          return email.isPrimary && email.contactType === 'email' ? email.value : null;
        }),
      phones:
        supplier.contacts &&
        supplier.contacts.contactInfo.map((mobile) => {
          return mobile.isPrimary && mobile.contactType === 'mobile' ? mobile.value : '';
        }),
      lastOrderAt: supplier.lastOrderAt ? this.dateService.formatDate(supplier.lastOrderAt, datetimeFormat.listD) : '',
      accPayableTerm: supplier.accPayableTerm ? supplier.accPayableTerm.name : '',
      amountOverDue: `${this.calculationService.roundOff(supplier.amountOverDue)}`,
      amountPayable: `${this.calculationService.roundOff(supplier.amountPayable)}`,
    }));
  }

  cannedInspectionListFormat(cannedInspections: any[]) {
    return cannedInspections.map((cannedInspection: any) => ({
      _id: cannedInspection._id,
      title: cannedInspection.title,
      categories: this.makeCategoryText(cannedInspection.category),
      count: cannedInspection.count,
      type: cannedInspection.isAlCertified ? 'AutoLeap Certified' : 'Custom',
      isAlCertified: cannedInspection.isAlCertified,
      category: cannedInspection.category,
    }));
  }

  estimateListFormat(orders: any[], data: any = {}) {
    const { startDateMilliSecond, endDateMilliSecond } = data;
    return orders.map((order: any) => {
      let vehicleLicense = '';
      const totalWithDeferred = this.calculationService.estimateTotalWithAllServices(order);
      const paid = sum([
        this.calculationService.roundOff(order.card),
        this.calculationService.roundOff(order.cheque),
        this.calculationService.roundOff(order.cash),
        this.calculationService.roundOff(order.creditPayment),
        this.calculationService.roundOff(order.thirdParty),
      ]);

      if (order.vehicleData && order.vehicleData[0]) {
        const { licensePlateNo = '', VIN = '' } = order.vehicleData[0];
        const vehicleFields = [];

        if (licensePlateNo) {
          vehicleFields.push(`Lic: ${licensePlateNo}`);
        }

        if (VIN) {
          vehicleFields.push(`VIN: ${VIN}`);
        }

        vehicleLicense = vehicleFields.filter((text: string) => text).join(' ');
      }

      if (order.invoiceDate) {
        order.invoiceDate = this.dateService.getCurrentDateTimeTz(new Date(order.invoiceDate).getTime());
        const invoiceDateMilliSecond = new Date(order.invoiceDate).getTime();
        if (startDateMilliSecond && endDateMilliSecond && startDateMilliSecond <= invoiceDateMilliSecond && endDateMilliSecond >= invoiceDateMilliSecond) {
          order.isOutSchedule = false;
        } else {
          order.isOutSchedule = true;
        }
      }

      order.total = order.estTotal;
      let finalizeType = OrderStateType[order.finalizeType];

      if (order.finalizeType === 'thirdPartyAccounts' && order.finalizeDetails?.thirdPartyAccount?.name) {
        finalizeType += ` - ${order.finalizeDetails?.thirdPartyAccount?.name}`;
      }

      return {
        paid,
        isArchived: order.isArchived,
        vehicleLicense,
        _id: order._id,
        shopId: order.shopId,
        statementId: order.statementId,
        code: order.code || '',
        lockedInvoiceWithStatement: order.lockedInvoiceWithStatement,
        invCode: order.orderStatus === 'invoice' ? order.invCode || order.code || '' : '',
        title: order.title,
        priority: order.priority && order.priority.name,
        customer: order.customer ? order.customer : '',
        company: (order.customer && order.customer.companyName) || '',
        vehicle: order.vehicle || {},
        vehicleData: order.vehicleData || {},
        associatedWarningTooltip: order.lockedInvoiceWithStatement
          ? 'Invoices with bulk payments cannot be transferred to new statement'
          : `Invoice is already part of statement "${order.statementName || ''}"`,
        outSideFilterRangeTooltip:
          startDateMilliSecond && endDateMilliSecond
            ? `Invoice# ${order.invCode} falls outside the date range ${this.dateService.formatDate(startDateMilliSecond, datetimeFormat.mmmdyyyy)} - ${this.dateService.formatDate(
                endDateMilliSecond,
                datetimeFormat.mmmdyyyy,
              )}`
            : '',

        workFlowStatus: order.workFlowStatus && order.workFlowStatus.name ? order.workFlowStatus.name : '',
        invoiceDate: order.invoiceDate,
        finalizeDate: order.finalizeDate,
        paymentStatus: order.isPaidFull ? 'Fully paid' : order.isPaidPartial ? 'Partially paid' : 'Unpaid',
        isAssociatedWithStatement: order.isAssociatedWithStatement,
        authorization: order.authorizationStatus === 'partially' ? 'Partially Approved' : order.authorizationStatus,
        orderStatus: order.orderStatus === 'estimate' ? 'Estimate' : 'Invoice',
        totalAmount: order.totalAmount || 0,
        totalEstimated: order.totalEstimated || 0,
        amountRemaining: order.amountRemaining,
        isOutSchedule: order.isOutSchedule,
        quickbook: order.qboId ? (order.isSyncedWithQBO ? 'Synced' : 'Not synced') : 'Not posted',
        attachmentCount: order.attachmentCount || 0,
        finalizeType,
      };
    });
  }

  statementInvoiceList(orders: any[], data: any = {}) {
    const { startDateMilliSecond, endDateMilliSecond } = data;

    return orders.map((order: any) => {
      let vehicleLicense = '';
      const paid = sum([
        this.calculationService.roundOff(order.card),
        this.calculationService.roundOff(order.cheque),
        this.calculationService.roundOff(order.cash),
        this.calculationService.roundOff(order.creditPayment),
        this.calculationService.roundOff(order.thirdParty),
      ]);

      if (order.vehicle && order.vehicle.vehicleId) {
        const { licensePlateNo = '', VIN = '' } = order.vehicle.vehicleId;
        const vehicleFields = [];

        if (licensePlateNo) {
          vehicleFields.push(`Lic: ${licensePlateNo}`);
        }

        if (VIN) {
          vehicleFields.push(`VIN: ${VIN}`);
        }

        vehicleLicense = vehicleFields.filter((text: string) => text).join(' ');
      }

      if (order.invoiceDate) {
        order.invoiceDate = this.dateService.getCurrentDateTimeTz(new Date(order.invoiceDate).getTime());
        const invoiceDateMilliSecond = new Date(order.invoiceDate).getTime();
        if (startDateMilliSecond && endDateMilliSecond && startDateMilliSecond <= invoiceDateMilliSecond && endDateMilliSecond >= invoiceDateMilliSecond) {
          order.isOutSchedule = false;
        } else {
          order.isOutSchedule = true;
        }
      }

      if (order.finalizationDate) {
        order.finalizationDate = this.dateService.getCurrentDateTimeTz(new Date(order.finalizationDate).getTime());
        const finalizeDateMilliSecond = new Date(order.finalizationDate).getTime();
        if (startDateMilliSecond && endDateMilliSecond && startDateMilliSecond <= finalizeDateMilliSecond && endDateMilliSecond >= finalizeDateMilliSecond) {
          order.isOutSchedule = false;
        } else {
          order.isOutSchedule = true;
        }
      }

      return {
        paid,
        vehicleLicense,
        _id: order._id,
        statementId: order.statementId,
        code: order.code || '',
        lockedInvoiceWithStatement: order.lockedInvoiceWithStatement,
        invCode: order.orderStatus === 'invoice' ? order.invCode || order.code || '' : '',
        title: order.title,
        vehicle: order.vehicle || {},
        // associatedWarningTooltip: order.lockedInvoiceWithStatement
        //   ? 'Invoices with bulk payments cannot be transferred to new statement'
        //   : `Invoice is already part of statement "${order.statementName || ''}"`,
        associatedWarningTooltip: `Invoice is already part of statement "${order.statementName || ''}`,
        outSideFilterRangeTooltip:
          startDateMilliSecond && endDateMilliSecond
            ? `Invoice# ${order.invCode} falls outside the date range ${this.dateService.formatDate(startDateMilliSecond, datetimeFormat.mmmdyyyy)} - ${this.dateService.formatDate(
                endDateMilliSecond,
                datetimeFormat.mmmdyyyy,
              )}`
            : '',
        invoiceDate: order.invoiceDate,
        finalizeDate: order.finalizeDate,
        paymentStatus: order.isPaidFull ? 'Fully paid' : order.isPaidPartial ? 'Partially paid' : 'Unpaid',
        isAssociatedWithStatement: order.isAssociatedWithStatement,
        orderStatus: order.orderStatus === 'estimate' ? 'Estimate' : 'Invoice',
        totalOrderAmount: order.total && order.total.grand ? order.total.grand : 0,
        amountRemaning: order.total.grand - paid,
        isOutSchedule: order.isOutSchedule,
        quickbook: order.qboId ? (order.isSyncedWithQBO ? 'Synced' : 'Not synced') : 'Not posted',
        restriction: order.restriction,
      };
    });
  }

  tireStorageFormat(tires: any[]) {
    const tireStorages = [];

    tires.forEach(
      ({
        _id,
        externalId,
        title,
        salesCode,
        category,
        tireStorageStatus,
        customer,
        vehicle,
        brand,
        model,
        size,
        tiresInfo,
        dateOfStorage,
        storageRO,
        scheduledRO,
        dateOfscheduledForReturn,
        dateOfRemoval,
        removalRO,
        associatedAppointmentId,
        inspection,
      }) => {
        const tire: any = {
          externalId,
          tireStorageId: _id,
          isInStorage: tireStorageStatus === 'store',
          isRemoved: tireStorageStatus === 'remove',
          isScheduled: tireStorageStatus === 'scheduledForReturn',
          storageStatus: tireStorageStatus === 'store' ? 'In Storage' : tireStorageStatus === 'scheduledForReturn' ? 'Scheduled for Return' : tireStorageStatus === 'remove' ? 'Removed' : 'Returned',
          detail: `${title}`,
          recommendReplacement: 0,
          count: 0,
          salesCode: this.helperService.displaySalesCodeTitle(salesCode, category),
          salesCodeShortName: salesCode?.shortName,
          category: category ? category.name : '',
          associatedAppointmentId,
          concatinatedTireDetails: tiresInfo?.length ? `${tiresInfo[0]?.brand?.name || ''} ${tiresInfo[0]?.model || ''} ${tiresInfo[0]?.size || ''}` : `${title}`,
        };

        if (customer) {
          tire.customerId = customer.customerId;
          tire.customer = customer.displayName;
          if (customer.phone) tire.phone = customer.phone;
        }

        if (vehicle) {
          tire.vehicleId = vehicle.vehicleId;
          tire.vehicle = vehicle.name;
        }

        if (dateOfStorage) {
          tire.dateOfStorage = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(dateOfStorage).getTime()), datetimeFormat.listD);
        }

        if (dateOfRemoval) {
          tire.dateOfRemoval = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(dateOfRemoval).getTime()), datetimeFormat.listD);
        }

        if (dateOfscheduledForReturn) {
          tire.dateOfscheduledForReturn = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(dateOfscheduledForReturn).getTime()), datetimeFormat.mmmdyyhhmmaa);
        }

        if (storageRO) {
          tire.storageRO = storageRO.code ? `${storageRO.code}` : '';
          tire.storageROId = storageRO.orderId;
        }

        if (scheduledRO) {
          tire.scheduledRO = scheduledRO.code ? `${scheduledRO.code}` : '';
          tire.scheduledROId = scheduledRO.orderId;
        }

        if (removalRO) {
          tire.removalRO = `RO# ${removalRO.code}`;
          tire.removalROId = removalRO.orderId;
        }

        if (tiresInfo && tiresInfo.length) {
          tire.count = tiresInfo.length;
          tire.recommendReplacement = tiresInfo.filter(({ recommendReplacement }) => recommendReplacement).length;
          tire.recommendReplacement += ` tire${tire.recommendReplacement ? 's' : ''} `;
          if (tiresInfo[0].storageLocation) {
            tire.location = tiresInfo[0].storageLocation.name;
            if (tiresInfo[0].storageBin && tiresInfo[0].storageBin.name) tire.location = `${tire.location}-${tiresInfo[0].storageBin.name}`;
          }

          tire.tiresInfo = tiresInfo.map((tireInfo) => {
            return {
              ...tireInfo,
              concatinatedTireDetails: `${tireInfo?.brand?.name || ''} ${tireInfo?.model || ''} ${tireInfo?.size || ''}`,
            };
          });

          try {
            if (inspection && inspection[0]) {
              const actualInspection = inspection[0];
              if (actualInspection?.category && actualInspection?.category?.length) {
                const { inspectionItems } = actualInspection?.category[0];
                if (inspectionItems) {
                  tire.tiresInfo = this.setTiresInfoInspectionData(tire.tiresInfo, inspectionItems);
                }
              }
            } else {
              tire.tiresInfo.forEach((info: any) => {
                let treadDepth = info.treadDepth?.includes('/') ? Number(info.treadDepth.split('/')[0]) : Number(info.treadDepth);
                info.depth = treadDepth;
              });
            }
          } catch (e) {
            console.log('Error in inspection data', e);
          }
        }

        tireStorages.push(tire);
      },
    );

    return tireStorages;
  }

  setTiresInfoInspectionData(tiresInfo: any[], inspectionItems: any[]) {
    if (!tiresInfo?.length) return [];

    return tiresInfo.map((info) => {
      const insItem = find(inspectionItems, { tireId: info._id });

      if (insItem) {
        const selectedConditions = insItem.conditions?.filter((c: any) => c?.isSelected) || [];

        if (selectedConditions?.length) {
          const matched = selectedConditions.find((c: any) => c.name?.includes('32'));
          if (matched) {
            const depth = matched?.name|| null;
            return {
              ...info,
              conditions: selectedConditions,
              depth,
            };
          }
        }
      }

      return info; // return original if no match found
    });
  }

  formatTireStorageHistory(tires: any[]) {
    const history = [];

    tires.forEach(
      ({
        tireStorageId,
        customerId,
        vehicleId,
        title,
        externalId,
        seasonality,
        storageRO,
        removalRO,
        dateOfStorage,
        dateOfRemoval,
        rimType,
        tireLabel,
        treadDepth,
        storageLocation,
        recommendReplacement,
      }) => {
        const tire: any = { tireStorageId, customerId, externalId, vehicleId, title, seasonality, rimType, tireLabel, treadDepth, storageLocation };

        if (storageRO && storageRO.orderId) {
          tire.storageRO = `${storageRO.code}`;
          tire.storageROId = storageRO.orderId;
        }

        if (storageLocation && storageLocation.name) {
          tire.storageLocation = storageLocation.name;
        }

        if (removalRO && removalRO.orderId) {
          tire.removalRO = `RO# ${removalRO.code}`;
          tire.removalROId = removalRO.orderId;
        }

        if (dateOfStorage) {
          tire.dateOfStorage = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(dateOfStorage).getTime()), datetimeFormat.listD);
        }

        if (dateOfRemoval) {
          tire.dateOfRemoval = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(dateOfRemoval).getTime()), datetimeFormat.listD);
        }

        tire.recommendReplacement = recommendReplacement ? 'Yes' : 'No';

        history.push(tire);
      },
    );

    return history;
  }

  formatAttendanceLogs(logs: any[], daysOfMonthMap: any) {
    return logs.map((log: any) => {
      const timesheetsPerDay = log.timesheetsPerDay || [];
      const formattedData = this.helperService.deepCopy(daysOfMonthMap);

      if (log.employee && log.employee._id) {
        formattedData.technicianId = log.employee._id;
        formattedData.technician = `${log.employee.firstName} ${log.employee.lastName}`;
        formattedData.totalHours = log.totalHours;
      } else {
        formattedData.technicianId = '';
        formattedData.technician = '';
      }

      timesheetsPerDay.forEach((timesheet: any) => {
        formattedData[timesheet.dayOfMonth] = this.calculationService.roundOff(timesheet.clockedHours);
      });

      return formattedData;
    });
  }

  formatAttendanceLogsExport(logs, daysOfMonthMap, daysNameMap) {
    return logs.map((log) => {
      const timesheetsPerDay = log.timesheetsPerDay || [];
      const formattedData = {};

      formattedData['Technician'] = log.employee && log.employee.firstName ? `${log.employee.firstName} ${log.employee.lastName}` : '';

      // now for each day of month
      Object.keys(daysOfMonthMap).forEach((dayNumber) => {
        // check if value against this day is present in timesheet
        let value = 0;
        timesheetsPerDay.forEach((dayCalculation) => {
          if (dayCalculation.dayOfMonth === dayNumber) {
            value = this.calculationService.roundOff(dayCalculation.clockedHours);
          }
        });
        formattedData[`${dayNumber} ${daysNameMap[dayNumber]}`] = value;
      });

      return formattedData;
    });
  }

  formatAttendanceLogDetails(logs: any[] = []) {
    const { isDTS } = this.helperService.getCompany();
    return logs.map((log) => ({
      startDate: log.start && log.order !== 'Clocked-out' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.start).getTime(), null, isDTS), datetimeFormat.hmma) : '-',
      endDate: log.end && log.order !== 'Clocked-in' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.end).getTime(), null, isDTS), datetimeFormat.hmma) : '-',
      duration: this.formateDuration(log.duration),
      technician: log.technician || '',
      ro: log.code ? log.code : log.order,
      service: log.service || '',
      createdDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.listDT) || '',
      //  this.dateService.formatDate(log.createdAt, datetimeFormat.listDT) || '',
      updatedAt: log.updatedAt
        ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.updatedAt).getTime()), datetimeFormat.listDT) || ''
        : this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.listDT) || '',
      status: log.workType === 'service' ? (log.action ? workStateTitle[log.action] : null) : null,
      updatedDate: this.dateService.getCurrentDateTimeTz(new Date(log.updatedAt).getTime(), null, isDTS),
      workType: log.workType || '',
      history: log.history,
      _id: log._id,
      orderId: log.orderId,
    }));
  }

  formatTechAttendanceLogDetails(logs) {
    return logs.map((log) => ({
      start: log.start && log.order !== 'Clocked-out' ? this.dateService.getCurrentDateTimeTz(new Date(log.start).getTime()) : '',
      end: log.end && log.order !== 'Clocked-in' ? this.dateService.getCurrentDateTimeTz(new Date(log.end).getTime()) : '',
      duration: this.formateDuration(log.duration),
      technician: log.technician || '',
      ro: log.code ? log.code : log.order,
      service: log.service || '',
      createdDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.listDT) || '',
      updatedDate: this.dateService.getCurrentDateTimeTz(new Date(log.updatedAt).getTime()),
      action: log.workType === 'service' ? (log.action ? log.action : null) : null,
      workType: log.workType || '',
      history: log.history,
      title: log.workType === 'service' ? log.service : null,
      workId: log.workType === 'service' ? log.workId : null,
      orderId: log.workType === 'service' ? log.orderId : null,
      _id: log._id,
    }));
  }

  formateDuration(duration = 0) {
    if (!duration) {
      return '';
    }
    const min = duration / 60;
    return `${Math.floor(min / 60)}h ${Math.round(min % 60)}m`;
  }

  formatAttendanceLogDetailsExport(logs) {
    return logs.map((log) => ({
      'Start Time': log.start && log.order !== 'Clocked-out' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.start).getTime()), datetimeFormat.listDT) : '',
      'End Time': log.end && log.order !== 'Clocked-in' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.end).getTime()), datetimeFormat.listDT) : '',
      Technician: log.technician || '',
      Duration: this.formateDuration(log.duration) || '',
      RO: log.order || '',
      Service: log.service || '',
      Status: log.workType === 'service' ? workStateTitle[log.action] : '',
    }));
  }

  formatCustomerReportExport(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        const totalPayments = sum([
          this.calculationService.roundOff(e.totalCard),
          this.calculationService.roundOff(e.totalCash),
          this.calculationService.roundOff(e.totalCheque),
          this.calculationService.roundOff(e.totalCreditPayment),
          this.calculationService.roundOff(e.totalThirdParty),
        ]);

        data.push({
          _id: e._id,
          Customer: e.displayName || '',
          Company: e.companyName || '',
          Email: e.email || '',
          Mobile: e.phone || '',
          'Created date': this.dateService.formatDate(e.createdAt, datetimeFormat.exportFormatD),
          'No. of vehicles': e.vehicles && e.vehicles.length ? e.vehicles.length : 0,
          'Total sales': e.totalSales ? Number(e.totalSales).toFixed(2) : 0,
          'Total Payments': totalPayments ? Number(totalPayments).toFixed(2) : 0,
          'Outstanding payments': Number(e.totalSales - totalPayments).toFixed(2),
        });
      }
    });
    return data;
  }

  paymentListFormat(payments: any[]) {
    return payments.map((payment: any) => {
      const estimate = payment.estimate.estimateId;
      const _payment: any = {
        _id: payment._id,
        previewLink: payment.previewLink,
        isPdfUploaded: payment.isPdfUploaded,
        estimateId: estimate._id || '',
        title: estimate.title || '',
        code: estimate || {},
        invCode: payment.orderStatus === 'invoice' ? payment.invCode || estimate.code || '' : '',
        paymentType: payment.paymentType,
        customer: payment.customer ? payment.customer : '',
        phone: payment.customer && payment.customer.phone ? payment.customer.phone : '',
        collectedAmount: payment.amount ? payment.amount : 0,
        amount: payment.amount ? payment.amount : 0,
        totalDue: estimate.total.grand || 0,
      };

      if (!!payment.paymentDate) {
        payment.createdAt = new Date(payment.paymentDate);
      } else {
        payment.createdAt = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
      }

      _payment.createdAt = payment.paymentDate ? this.dateService.formatDate(payment.paymentDate, datetimeFormat.mmmdyyyy) : this.dateService.formatDate(payment.createdAt, datetimeFormat.mmmdyyyy);

      return _payment;
    });
  }

  deferredServicesListFormat(deferredServices: any[]) {
    return deferredServices.map((deferredService: any) => {
      return deferredService;
    });
  }

  formatPaymentReportList(payments: any[], featurePayrix?: boolean) {
    return payments.map((payment: any) => {
      const estimate = payment.estimate || {};
      const _payment = {
        _id: payment._id,
        shopId: payment.shopId,
        group: payment.group || '',
        customer: payment.customer || {},
        estimate: estimate,
        order: `${estimate.code} - ${estimate.title}` || {},
        invCode: payment.orderStatus === 'invoice' ? payment.invCode || payment.code || '' : '',
        estimateId: estimate._id || '',
        paymentDateTime: payment.paymentDate ? this.dateService.formatDate(payment.paymentDate, datetimeFormat.listD) : this.dateService.formatDate(payment.createdAt, datetimeFormat.listD),
        customerName: (payment.customer && payment.customer.displayName) || '',
        companyName: (payment.customer && payment.customer.companyName) || '',
        paymentType: this.getPaymentType(featurePayrix, payment),
        payrixResponse: payment.payrixResponse,
        isOnline: payment.isOnline,
        isCardSwipe: payment.isCardSwipe,
        paymentSubType:
          payment.paymentMethod && payment.paymentMethod.name ? `${payment.isCreditPayment ? `${payment.paymentMethod.name} (${payment.paymentMethod.code})` : payment.paymentMethod.name}` : '',
        amount:
          payment.group && (payment.group === 'Refund' || payment.group === 'Void')
            ? -1 * this.calculationService.roundOffToDecimalPlaces(payment.amount) || 0
            : this.calculationService.roundOffToDecimalPlaces(payment.amount) || 0,
        orderAmount: this.calculationService.roundOffToDecimalPlaces(estimate.total.grand) || 0,
        remainingAmount: this.calculationService.roundOffToDecimalPlaces(payment.remainingAmount || 0),
        note: payment?.refunds && payment?.refunds?.notes ? payment?.refunds?.notes : payment?.notes || 'N/A',
        qboStatus: payment.isSyncedWithQBO ? 'Synced' : payment.qboId ? 'Out of Sync' : 'Not posted',
        groupTitle: this.setPaymentGroupTitle(payment),
      };
      console.log('payment.refund', payment);

      return _payment;
    });
  }

  setPaymentGroupTitle(payment) {
    if (payment?.group === 'Refund') {
      return payment.isVoidPayment ? 'Void' : 'Refund';
    } else {
      return payment.group;
    }
  }

  getPaymentType(featurePayrix: boolean, payment: any) {
    let type = payment.paymentType;
    if (payment.isOnline) type = 'card online';
    else if (payment.isCardSwipe) type = 'card swipe';
    else if (payment.paymentType == 'card' && featurePayrix) type = 'card manual';
    else if (payment.isCreditPayment) type = 'Credit';
    else if (paymentTypeTitle[payment.paymentType]) type = paymentTypeTitle[payment.paymentType];

    return type;
  }
  formatSupplierReportList(supplierData: any[]) {
    return supplierData.map((supplier: any) => ({
      _id: supplier._id,
      supplierName: supplier.supplierName,
      suppliertype: `${supplier.suppliertype === 'QBO' ? 'Internal' : supplier.suppliertype}` || '',
      inventoryNumberOfItemsPurchased: supplier.inventoryNumberOfItemsPurchased + supplier.onlineNumberOfItemsPurchased + supplier.provisionalNumberOfItemsPurchased || 0,
      inventoryVolumePurchased: supplier.inventoryVolumePurchased + supplier.onlineVolumePurchased + supplier.provisionalVolumePurchased || 0,
      inventoryTotalPurchaseValue: supplier.inventoryTotalPurchaseValue + supplier.onlineTotalPurchaseValue + supplier.provisionalTotalPurchaseValue || 0,
      totalNumberOfItemsPurchased: supplier.totalNumberOfItemsPurchased || 0,
      totalVolumePurchased: supplier.totalVolumePurchased || 0,
      totalPurchaseValue: supplier.totalPurchaseValue || 0,
    }));
  }

  formatSupplierReportSummaryList(supplierData: any[]) {
    return supplierData.map((supplier: any) => ({
      _id: supplier._id,
      supplierName: supplier.supplierName,
      suppliertype: supplier.supplierType === 'QBO' ? 'internal' : supplier.supplierType || '',
      totalNumberOfItemsPurchased: supplier.itemValue || 0,
      totalNumberOfCoreReturned: supplier.itemCore || 0,
      totalNumberOfItemsReturned: supplier.itemReturn || 0,
      totalNetPurchaseValue: supplier.netValue || 0,
    }));
  }

  formatCommissionDrillDownReport(records: any[], exporting?: boolean) {
    const roleLabel = {
      admin: 'Admin',
      tech: 'Tech',
      serviceWriter: 'Service Advisor',
    };
    if (records && records.length) {
      records.forEach((data: any) => {
        if (data.firstName && data.lastName) {
          data.name = `${data.firstName} ${data.lastName}`;
        }

        if (data.commissionName && data.commissionName.length) {
          data.commissionName = data.commissionName.join(' | ');
        }

        if (data.commissionDetail && data.commissionDetail.length) {
          data.commissionDetail = data.commissionDetail.join(!exporting ? '<br/>' : ' | ');
        }

        if (data.role && data.role.length) {
          data.role = data.role.map((el) => roleLabel[el]).join(' | ');
        }
      });
    }
    return records;
  }

  formatUnusedPartReport(orders: any[]) {
    return orders.map((order: any) => {
      order.rOStatus = order.rOStatus === 'estimate' ? 'Estimate' : 'Invoice';
      order.serviceQty = order.serviceQty || 0;
      order.type = order.type === 'part' ? 'Part' : 'Tire';
      order.qtyReturned = order.qtyReturned || 0;
      order.qtyAddedToInventory = order.qtyAddedToInventory || 0;
      order.unusedQty = order.unusedQty || 0;
      order.cost = order.cost || 0;
      order.stockValue = order.stockValue || 0;
      order.taxValue = order.taxValue || 0;
      order.unUsedStockValue = order.unUsedStockValue || 0;
      order.amount = order.amount || 0;

      if (order.orderDate && order.orderDate.length) {
        order.orderDate = order.orderDate.map((date: any) => {
          if (date) {
            return this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(date).getTime()), datetimeFormat.mmmdyyhhmmaa);
          }
        });
      }

      return order;
    });
  }

  formatCommissionReportList(records: any[], exporting?: boolean) {
    const roleLabel: any = {
      admin: 'Admin',
      tech: 'Tech',
      serviceWriter: 'Service Advisor',
    };
    if (records && records.length) {
      records.forEach((data: any) => {
        if (data.firstName && data.lastName) {
          data.name = `${data.firstName} ${data.lastName}`;
        }

        if (data.commissionName && data.commissionName.length) {
          data.commissionName = data.commissionName.join(' | ');
        }

        if (data.commissionDetail && data.commissionDetail.length) {
          data.commissionDetail = data.commissionDetail.join(!exporting ? '<br/>' : ' | ');
        }

        if (data.role && data.role.length) {
          if (data.role.length > 1) {
            data.role = 'Hybrid';
          } else {
            data.role = roleLabel[data.role];
          }
        }
      });
    }
    return records;
  }

  formateCatlogActivityLogs(records: any[]) {
    if (records && records.length) {
      records = records.map((data: any) => {
        if (data && data?.entityAction) {
          let entityAction = data.entityAction;

          if (entityAction === 'received') {
            entityAction = 'delivered';
          } else if (entityAction === 'markedAsInventory') {
            entityAction = 'added to Inventory';
          } else if (entityAction === 'coreReturned') {
            entityAction = 'Returned';
          }

          const log: any = {
            title: data.title,
            actionType: entityAction ? (entityAction === 'Returned' ? 'Core ' : 'Item ') + entityAction : '',
            actionBy: data.actionBy,
            date: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(data.createdAt).getTime()), datetimeFormat.mmmdyyyy),
            time: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(data.createdAt).getTime()), datetimeFormat.hhmmA),
            text: data.text,
            logSource: data?.data?.logSource || '',
            orderId: data?.data?.orderId || '',
            poNumber: this.getPoNumber(data?.data),
            redirectUrl: this.redirectURL(data),
            shopId: data?.shopId,
            entityType: data?.entityType,
          };

          if (log.title && log.title.includes('Sales code')) {
            log.actionType = log.title;
          }

          if (data?.data?.isCombineLogs && data.data.isAttributeBasedPricingEnable && this.helperService.getCompany()?.isMultiLocationEnabled) {
            log.shopName = this.dataService.shopsMap[data?.shopId]?.shopName;
          } else if (data?.data?.isCombineLogs && !data.data.isAttributeBasedPricingEnable && this.helperService.getCompany()?.isMultiLocationEnabled) {
            if (Object.keys(data?.data?.shopsMap || {})?.length) {
              log.shopName = data?.data?.shopsMap[data?.data?.shopId];
            } else {
              log.shopName = this.dataService.shopsMap[data?.data?.shopId]?.shopName;
            }
          }

          return log;
        }
      });
      return records.filter((data: any) => {
        if (`${data.shopId}` !== `${this.helperService.getCurrentShopId()}` && data.entityType !== 'catalog-item') {
          return false;
        } else {
          return true;
        }
      });
    }
  }

  getPoNumber(data) {
    if (data && data?.logSource === 'po' && data.code) {
      return `PO#${data.code}`;
    } else if (data && data?.logSource === 'ro' && data.code) {
      return `RO#${data.code}`;
    } else if (data && data?.logSource === 'roSale' && data.code) {
      return `RO#${data.code}`;
    }
    return '';
  }

  redirectURL(data) {
    if (data?.data && data?.data?.logSource && data?.data?.orderId) {
      if (data?.data?.logSource === 'po') {
        return `${config.redirectUrl.purchaseOrder}/${data?.data?.orderId}`;
      } else if (data?.data?.logSource === 'ro' || data?.data?.logSource === 'roSale') {
        return `/estimate/${data?.data?.orderId}`;
      }
    }
    return '';
  }

  formatTaxByItemList(TaxByItemData: any[]) {
    return TaxByItemData.map((taxItem: any) => {
      const nonTaxableAmt = this.calculationService.roundOff(taxItem.nonTaxableAmt || 0);
      const tax = this.calculationService.roundOff(taxItem.tax || 0);
      const taxableAmt = this.calculationService.roundOff(taxItem.taxableAmt || 0);
      const total = this.calculationService.roundOff(taxItem.total || 0);

      return {
        _id: taxItem._id,
        nonTaxableAmt: this.formatCurrency(nonTaxableAmt),
        tax: this.formatCurrency(tax),
        taxableAmt: this.formatCurrency(taxableAmt),
        total: this.formatCurrency(total),
        typeLabel: itemTypeLabel[taxItem.type],
        type: taxItem.type === 'passThroughTax' ? 'passThroughTax' : taxItem.type,
      };
    });
  }

  formatCurrency(value: number = 0) {
    if (value < 0) {
      return `(${this.currencyPipe.transform(Math.abs(value), currency.USD)})`;
    } else {
      return this.currencyPipe.transform(value, currency.USD);
    }
  }

  formatItemsSoldReportList(itemSoldData: any[], isDrillDown = false) {
    // console.log('item', itemSoldData)
    return itemSoldData.map((item: any) => ({
      _id: item._id,
      description: item?.description,
      descriptionFR: item?.descriptionFR,
      itemType: item.itemType,
      itemName: item.itemName,
      itemNumber: item.itemNumber,
      salesCode: item.salesCode || '',
      salesGroup: item.salesGroup || '',
      itemCategory: item.itemCategory || '',
      serviceWriter: item.serviceWriter || '-',
      inventoryItem: item.inventoryItem ? 'Yes' : 'No',
      salesVolume: this.calculationService.roundOff(item.salesVolume || 0),
      salesValue: this.calculationService.roundOff(item.salesValue || 0),
      paymentStatus: item.isPaidFull ? 'Fully paid' : item.isPaidPartial ? 'Partially paid' : 'Unpaid',
      totalSalesValue: this.calculationService.roundOff(item.totalSalesValue || 0),
      totalCostValue: this.calculationService.roundOff(item.totalCostValue || 0),
      profitability: isDrillDown ? this.calculationService.roundOff(item.updatedprofitability) : this.calculationService.roundOff(item.profitability) || 10,
      updatedprofitability: this.calculationService.roundOff(item.updatedprofitability || 10),
      averageCost: this.calculationService.roundOff(item.averageCost || 0),
      avgprofatibilty: isDrillDown ? (item.profitability ? `${this.calculationService.roundOff(item.profitability)}%` : 0) : this.calculationService.roundOff(item.avgprofatibilty) ? `${(item.avgprofatibilty * 100).toFixed(2)}%` : 0,
      technician: item.serviceTechs,
      technicianString: item.serviceTechs && item?.serviceTechs?.length ? item?.serviceTechs.map((tech) => tech.name).join(', ') : '',
      roNumber: item.roNumber || '',
      invCode: item.invCode || '',
      invoiceDate: item.invoiceDate,
      customerName: item.customer?.displayName || '',
      customerEmail: item.customer?.email || '',
      customerPhone: item.customer?.phone || '',
      vehicleName: item.vehicle?.name || '',
      supplier: item.supplier || '',
      markup: this.calculationService.roundOff(item.markup || 0),
      cost: this.calculationService.roundOff(item.cost || 0),
      price: this.calculationService.roundOff(item.price || 0),
      quantity: this.calculationService.roundOff(item.quantity || 0),
      tax: this.calculationService.roundOff(item.tax || 0),
      discount: this.calculationService.roundOff(item.discount || 0),
      subTotalCost: this.calculationService.roundOff(item.subTotalCost || 0),
      subTotal: this.calculationService.roundOff(item.subTotal || 0),
      finalizeType: item.finalizeType || '',
      finalizeDate: item.finalizeDate,
      totalPricePerUnitValue: this.calculationService.roundOff(item.totalPricePerUnitValue || 0),
      brand: item.brand || '',
      model: item.model || '',
      size: item.size || '',
      tireType: item.tireType || '',
      loadIndex: item.loadIndex || '',
      loadIndexDual: item.loadIndexDual || '',
      speedRating: item.speedRating || '',
      loadRange: item.loadRange || '',
      sideWallStyle: item.sideWallStyle || '',
      utqg: item.utqg || '',
      warranty: item.warranty || '',
    }));
  }

  formatFeeReportList(itemSoldData: any[]) {
    return itemSoldData.map((item: any) => ({
      _id: item._id,
      name: item.name,
      cost: this.currencyPipe.transform(item.avgCost || 0, currency.USD),
      price: this.currencyPipe.transform(item.avgPrice || 0, currency.USD),
      profitability: item.profitability ? `${Number(item.profitability).toFixed(2)}%` : '',
      timeSold: item.sold,
      qtySold: item.qtySold,
      totalCost: this.currencyPipe.transform(item.cost || 0, currency.USD),
      totalPrice: this.currencyPipe.transform(item.price || 0, currency.USD),
      type: item.type === 'order' ? 'RO level' : item.type === 'service' ? 'Service level' : 'Passthrough Tax',
    }));
  }

  formatDiscountReportList(itemSoldData: any[]) {
    return itemSoldData.map((item: any) => ({
      // _id: item._id,
      discountName: item.name,
      appliedOn: item.type === 'order' ? 'Order Level' : 'Service Level',
      discountType: item.discountType === 'percentage' ? 'Percentage' : 'Dollar Value',
      averageDiscount: this.calculationService.roundOff(item.avgPrice),
      addedToRO: item.sold,
    }));
  }

  formatFeeByIdReportList(itemSoldData: any[]) {
    return itemSoldData.map((item: any) => ({
      orderCode: item.orderCode,
      invoiceDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(item.invoiceDate).getTime()), datetimeFormat.ddmmyyyy),
      finalizeDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(item.finalizeDate).getTime()), datetimeFormat.ddmmyyyy),
      finalizeType: item.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[item.finalizeType]} ${item.thirdPartyAccount || ''}` : this.finalizeTypeLabel[item.finalizeType || ''],
      price: Number(item.price).toFixed(2),
      cost: Number(item.cost).toFixed(2),
      count: Number(item.count).toFixed(2),
      totalPrice: Number(item.totalPrice).toFixed(2),
      totalCost: Number(item.totalCost).toFixed(2),
      profitability: Number(item.profitability).toFixed(2),
      shopId: item?.shopId || '',
    }));
  }

  formatDiscountByIdReportList(itemSoldData: any[]) {
    return itemSoldData.map((item: any) => ({
      appliedOn: item.discountOn === 'order' ? 'Order Level' : 'Service Level',
      shopId: item?.shopId || '',
      discountType: item.discountType === 'percentage' ? 'Percentage' : 'Dollar value',
      discountValue: item.discountValue.toFixed(2) + `${item.discountType === 'percentage' ? '%' : ''}`,
      roNumber: `${item.orderCode}`,
      customerName: item.customerName,
      orderValue: item.orderValue.toFixed(2),
      valueOnRO: item.discountValueOnOrder.toFixed(2),
    }));
  }

  formatLaborItemsSoldReportList(itemSoldData: any[]) {
    return itemSoldData.map((item: any) => ({
      avgprofatibilty: item.avgprofatibilty || 0,
      avgEstimateHours: item.avgEstimateHours || 0,
      avgBillableHours: item.avgBillableHours || 0,
      avgCost: item.avgCost || 0,
      avgPrice: item.avgPrice || 0,
      itemSource: item.itemSource,
      itemCode: item.itemCode || null,
      _id: item._id,
      itemName: item.itemName,
      timeSold: item.timeSold || 0,
      nameSort: item.nameSort || '',
      ordecreatedAt: item.ordecreatedAt || '',
      totalEstimateHours: item.totalEstimateHours || 0,
      totalBillableHours: item.totalBillableHours || 0,
      totalHoursWorked: item.totalHoursWorked || 0,
      totalCost: item.totalCost || 0,
      totalSales: item.totalSales || 0,
      totalProfitability: item.totalProfitability || 0,
    }));
  }

  formatItemsRecordsList(itemsData: any[]) {
    return itemsData.map((item: any) => ({
      roNumber: item.roNumber || '-',
      invCode: item.invCode,
      shopId: item?.shopId || '',
      itemType: item.itemType,
      itemName: item.itemName,
      itemNumber: item.itemNumber,
      customer: item.customer,
      vehicle: item.vehicle,
      customerName: item.customer?.displayName,
      customerEmail: item.customer?.email,
      customerPhone: item.customer?.phone,
      vehicleName: item.vehicle?.name,
      dotNumbers: item.dotNumbers ? item.dotNumbers : [],
      invoiceDate: item.invoiceDate ? this.dateService.formatDate(item.invoiceDate, datetimeFormat.listD) : '-',
      finalizeDate: item.finalizeDate ? this.dateService.formatDate(item.finalizeDate, datetimeFormat.listD) : '-',
      finalizeType: item.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[item.finalizeType]} ${item.thirdPartyAccount || ''}` : this.finalizeTypeLabel[item.finalizeType || ''],
      supplier: item.supplier || '',
      serviceWriter: item.serviceWriter || '',
      cost: `${this.calculationService.roundOff(item.cost)}` || 0,
      markup: `${this.calculationService.roundOff(item.markup)}` || 0,
      price: `${this.calculationService.roundOff(item.price)}` || 0,
      quantity: item.quantity || 0,
      tax: item.tax || 0,
      discount: item.discount || 0,
      subTotal: item.subTotal || 0,
      profitability: `${this.calculationService.roundOff(item.profitability)}%` || 0,
      updatedprofitability: `${this.calculationService.roundOff(item?.updatedprofitability)}` || 0,
      // updatedprofitability: item.updatedprofitability.toFixed(2) || 0,
      estimatedHours: item.estimatedHours || 0,
      estimatedRate: item.estimatedRate || 0,
      totalHours: item.totalHours || 0,
      billableHours: item.billableHours || 0,
      billableRate: item.billableRate || 0,
      sales: item.sales || 0,
      orderId: item.orderId,
      salesCode: item.salesCode,
      salesGroup: item.salesGroup,
      source: item.source,
      paymentStatus: item.isPaidFull ? 'Fully paid' : item.isPaidPartial ? 'Partially paid' : 'Unpaid',
      technician: item.serviceTechs,
      technicianString: item.serviceTechs && item?.serviceTechs?.length ? item?.serviceTechs.map((tech) => tech.name).join(', ') : '',
      subTotalCost: `${this.calculationService.roundOff(item.subTotalCost)}` || 0,
      brand: item.brand || '',
      model: item.model || '',
      size: item.size || '',
      tireType: item.tireType || '',
      loadIndex: item.loadIndex || '',
      loadIndexDual: item.loadIndexDual || '',
      speedRating: item.speedRating || '',
      loadRange: item.loadRange || '',
      sideWallStyle: item.sideWallStyle || '',
      utqg: item.utqg || '',
      warranty: item.warranty || '',
    }));
  }

  formatLaborDrillDown(items: any[]) {
    return items.map((item: any) => ({
      roNumber: item.roNumber || '-',
      invoiceDate: item.invoiceDate ? this.dateService.formatDate(item.invoiceDate, datetimeFormat.listD) : '-',
      finalizeDate: item.finalizeDate ? this.dateService.formatDate(item.finalizeDate, datetimeFormat.listD) : '-',
      finalizeType: item.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[item.finalizeType]} ${item.thirdPartyAccount || ''}` : this.finalizeTypeLabel[item.finalizeType] || '',
      shopId: item?.shopId || '',
      supplier: item.supplier || '',
      cost: item.cost || 0,
      markup: item.markup || 0,
      price: item.price || 0,
      quantity: item.quantity || 0,
      tax: item.tax || 0,
      discount: this.calculationService.roundOff(item.discount) || 0,
      subTotal: item.subTotal || 0,
      estimatedHours: item.estimatedHours || 0,
      estimatedRate: this.calculationService.roundOff(item.estimatedRate) || 0,
      totalHours: item.totalHours || 0,
      sales: item.sales || 0,
      profitability: item.profitability || 0,
      billableHours: item.billableHours || 0,
      billableRate: item.billableRate || 0,
    }));
  }

  formatSupplierDetailsList(suppliers: any[]) {
    const paymentStatus = {
      PAYABLE: 'Payable',
      COD: 'COD',
    };
    const orderingStatus = {
      draft: 'Unordered',
      ordered: 'Ordered',
      cancelled: 'Cancelled',
      received: 'Delivered',
    };
    return suppliers.map((supplier: any) => {
      const _supplier = {
        _id: supplier._id,
        supplierName: supplier.supplierName || '',
        suppliertype:
          (supplier.suppliertype && `${supplier.suppliertype === 'QBO' ? 'Internal' : supplier.suppliertype}`) ||
          (supplier.supplierType && `${supplier.supplierType === 'QBO' ? 'Internal' : supplier.supplierType}`) ||
          'Internal',
        activityDate: supplier.activityDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.activityDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        activityType: supplier.activityType || '',
        itemType: supplier.itemType || '',
        itemName: supplier.itemName || '',
        paymentStatus: supplier.paymentStatus || paymentStatus[supplier.paymentStatus],
        orderingStatus: orderingStatus[supplier.orderingStatus],
        orderingMethod: supplier.orderingMethod || '',
        pos: (supplier.pos && supplier.pos[0]) || '',
        ros: (supplier.ros && supplier.ros[0]) || '',
        cost: supplier.cost,
        quantity: supplier.quantity || '',
        taxedAmount: supplier.taxedAmount || 0,
        subTotal: supplier.subTotal || 0,
        orderId: supplier.orderId,
        deliveryDate: supplier.deliveryDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.deliveryDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        cartId: supplier.cartId,
        source: supplier.source,
      };
      return _supplier;
    });
  }

  formatExportSupplierSummaryList(suppliers: any[]) {
    const orderingStatus = {
      draft: 'Unordered',
      ordered: 'Ordered',
      cancelled: 'Cancelled',
      received: 'Delivered',
      Delivered: 'Delivered',
    };
    return suppliers.map((supplier: any) => {
      const _supplier = {
        _id: supplier._id,
        supplierName: supplier.supplierName || '',
        suppliertype:
          (supplier.suppliertype && `${supplier.suppliertype === 'QBO' ? 'Internal' : supplier.suppliertype}`) ||
          (supplier.supplierType && `${supplier.supplierType === 'QBO' ? 'Internal' : supplier.supplierType}`) ||
          'Internal',
        activityDate: supplier.activityDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.activityDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        deliveryDate: supplier.deliveryDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.deliveryDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        supplierReturnInvDate: supplier.supplierInvDate
          ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.supplierInvDate).getTime()), datetimeFormat.mmmdyyyy)
          : '',
        supplierReturnInv: supplier.supplierInvNum,
        creditNo: supplier.creditNo,
        activityType: supplier.activityType || '',
        itemType: supplier.itemType || '',
        itemName: supplier.itemName || '',
        orderingStatus: orderingStatus[supplier.orderStatus],
        orderingMethod: supplier.orderingMethod || '',
        pos: supplier.pONo || '',
        ros: supplier.rONo || '',
        roInvoiceNumber: supplier.roInvNo || '',
        warehouse: (supplier.warehouse && supplier.warehouse.name) || '',
        location: supplier.roShopId || supplier.poShopId,
        cost: supplier.cost,
        coreCost: supplier.coreCost || 0,
        quantityReturn: supplier.quantityReturn || 0,
        itemCore: supplier.itemCore || 0,
        itemReturn: supplier.itemReturn || 0,
        quantity: supplier.quantity || '',
        taxedAmount: supplier.tax || 0,
        subTotal: supplier.subTotal || 0,
        orderId: supplier.orderId || '',
        paymentTerms: supplier.paymentTerms || '',
        itemNumber: supplier.itemNumber || '',
        supplierInvNum: supplier.supplierInvNum || '',
        // unitBaseCost: supplier.unitBaseCost || '',
        unitCost: supplier.unitCost || '',
        totalPreTax: supplier.totalPreTax || '',
        totalPostTax: supplier.totalPostTax || '',
        supplierInvDate: supplier.supplierInvDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.supplierInvDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        creationDate: supplier.creationDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.creationDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        orderedDate: supplier.orderedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.orderedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        purchaseOrderId: supplier.purchaseOrderId || '',
        //Core Related Fields
        // unitCoreCost: supplier.unitCoreCost || 0,
        coreTotalPreTax: supplier.coreTotalPreTax || 0,
        coreTaxAmt: supplier.coreTaxAmt || 0,
        coreTotalPostTax: supplier.coreTotalPostTax || 0,
        refundedAmount: supplier.refundedAmount || 0,
        coreCreationDate: supplier.markedCoreOn ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.markedCoreOn).getTime()), datetimeFormat.mmmdyyyy) : '',

        //Return Related Fields
        returnUnitCost: supplier.returnUnitCost || 0,
        returnTotalPreTax: supplier.returnTotalPreTax || 0,
        returnTaxAmt: supplier.returnTaxAmt || 0,
        returnTotalPostTax: supplier.returnTotalPostTax || 0,
        returnCreationDate: supplier.itemReturnDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.itemReturnDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        shippedDate: supplier.shippedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.shippedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        refundedDate: supplier.refundedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.refundedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        deliveredDate: supplier.deliveredDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.deliveredDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        returnSupplierInvNum: supplier.supplierInvNum || '',
        returnType: supplier.returnType || '',
        cartId: supplier.cartId,
        source: supplier.source,
        markedCoreOn: supplier.markedCoreOn,
      };
      return _supplier;
    });
  }

  formatSupplierSummaryList(suppliers: any[]) {
    const orderingStatus = {
      draft: 'Unordered',
      ordered: 'Ordered',
      cancelled: 'Cancelled',
      received: 'Delivered',
      Delivered: 'Delivered',
      delivered: 'Delivered',
    };
    return suppliers.map((supplier: any) => {
      const _supplier = {
        _id: supplier._id,
        supplierName: supplier.supplierName || '',
        suppliertype:
          (supplier.suppliertype && `${supplier.suppliertype === 'QBO' ? 'Internal' : supplier.suppliertype}`) ||
          (supplier.supplierType && `${supplier.supplierType === 'QBO' ? 'Internal' : supplier.supplierType}`) ||
          'Internal',
        activityDate: supplier.activityDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.activityDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        deliveryDate: supplier.deliveryDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.deliveryDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        supplierReturnInvDate: supplier.supplierInvDate
          ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.supplierInvDate).getTime()), datetimeFormat.mmmdyyyy)
          : '',
        supplierReturnInv: supplier.supplierInvNum,
        creditNo: supplier.creditNo,
        activityType: supplier.activityType || '',
        itemType: supplier.itemType || '',
        itemName: supplier.itemName || '',
        orderingStatus: orderingStatus[supplier.orderStatus],
        orderingMethod: supplier.orderingMethod || '',
        pos: supplier.pONo || '',
        ros: supplier.rONo || '',
        roInvoiceNumber: supplier.roInvNo || '',
        warehouse: (supplier.warehouse && supplier.warehouse.name) || supplier.warehouse || '',
        location: supplier.location || '',
        cost: supplier.cost,
        coreCost: supplier.coreCost || 0,
        quantityReturn: supplier.quantityReturn || 0,
        itemCore: supplier.itemCore || 0,
        itemReturn: supplier.itemReturn || 0,
        quantity: supplier.quantity || '',
        taxedAmount: supplier.tax || 0,
        subTotal: supplier.subTotal || 0,
        orderId: supplier.orderId || '',
        paymentTerms: supplier.paymentTerms || '',
        itemNumber: supplier.itemNumber || '',
        supplierInvNum: supplier.supplierInvNum || '',
        // unitBaseCost: supplier.unitBaseCost || '',
        unitCost: supplier.unitCost || '',
        totalPreTax: supplier.totalPreTax || '',
        totalPostTax: supplier.totalPostTax || '',
        supplierInvDate: supplier.supplierInvDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.supplierInvDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        creationDate: supplier.creationDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.creationDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        orderedDate: supplier.orderedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.orderedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        purchaseOrderId: supplier.purchaseOrderId || '',
        //Core Related Fields
        // unitCoreCost: supplier.unitCoreCost || 0,
        coreTotalPreTax: supplier.coreTotalPreTax || 0,
        coreTaxAmt: supplier.coreTaxAmt || supplier.coreTotalPreTax * (supplier.tax / 100) || 0,
        coreTotalPostTax: supplier.coreTotalPostTax || 0,
        refundedAmount: supplier.refundedAmount || 0,
        coreCreationDate: supplier.markedCoreOn ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.markedCoreOn).getTime()), datetimeFormat.mmmdyyyy) : '',

        //Return Related Fields
        returnUnitCost: supplier.returnUnitCost || 0,
        returnTotalPreTax: supplier.returnTotalPreTax || 0,
        returnTaxAmt: supplier.returnTaxAmt || supplier.tax || 0,
        returnTotalPostTax: supplier.returnTotalPostTax || 0,
        returnCreationDate: supplier.itemReturnDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.itemReturnDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        shippedDate: supplier.shippedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.shippedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        refundedDate: supplier.refundedDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.refundedDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        deliveredDate: supplier.deliveredDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(supplier.deliveredDate).getTime()), datetimeFormat.mmmdyyyy) : '',
        returnSupplierInvNum: supplier.supplierInvNum || '',
        returnType: supplier.returnType || '',
        cartId: supplier.cartId,
        source: supplier.source,
        markedCoreOn: supplier.markedCoreOn,
        groupId: supplier.groupId,
      };

      if (_supplier.coreTaxAmt) {
        _supplier.coreTotalPostTax = _supplier.coreTotalPostTax + _supplier.coreTaxAmt;
      }

      // if (_supplier.returnTaxAmt) {
      //   _supplier.returnTotalPostTax = _supplier.returnTotalPostTax + _supplier.returnTaxAmt
      // }
      return _supplier;
    });
  }

  formatTaxDetailsByTypeList(taxDetails: any[]) {
    return taxDetails.map((taxDetail: any) => {
      const _supplier = {
        roId: taxDetail.roId,
        _id: taxDetail._id,
        type: taxDetail.type === 'passThroughTax' ? 'Passthrough Tax' : taxDetail.type,
        typeLabel: itemTypeLabel[taxDetail.type] || '',
        name: taxDetail.name || '',
        itemNumber: taxDetail.itemNumber || '',
        roCode: taxDetail.roCode,
        customer: taxDetail.customer || '',
        taxAble: taxDetail.taxAble ? 'Yes' : 'No',
        taxCode: taxDetail.taxCode || 0,
        serviceWriter: taxDetail.serviceWriter || '',
        taxAbleAmt: this.calculationService.roundOff(taxDetail.taxAbleAmt) || 0,
        nonTaxAbleAmt: this.calculationService.roundOff(taxDetail.nonTaxAbleAmt) || 0,
        taxAmt: this.calculationService.roundOff(taxDetail.taxAmt) || 0,
        shopId: taxDetail?.shopId || '',
      };
      return _supplier;
    });
  }

  formatPaymentReportExport(payments: any[]) {
    return payments.map((payment: any) => {
      const estimate = payment.estimate || {};
      const _payment = {
        _id: payment._id,
        shopId: payment.shopId,
        customer: payment.customer || {},
        estimate: estimate,
        Order: `${estimate.code} - ${estimate.title}` || {},
        'Invoice #': payment.orderStatus === 'invoice' ? payment.invCode || payment.code || '' : '',
        estimateId: estimate._id || '',
        'Payment date': payment.paymentDate
          ? this.dateService.formatDate(payment.paymentDate, datetimeFormat.exportFormatD)
          : this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime()), datetimeFormat.exportFormatD),
        Customer: (payment.customer && payment.customer.fullName) || '',
        Company: (payment.customer && payment.customer.companyName) || '',
        'Payment type': payment.paymentType === 'cheque' ? 'check' : payment.isCreditPayment ? 'Credit' : payment.paymentType,
        'Payment method':
          payment.isCreditPayment && payment.paymentMethod ? `${payment.paymentMethod.name} (${payment.paymentMethod.code})` : (payment.paymentMethod && payment.paymentMethod.name) || '',
        'Payment amount':
          payment.group == 'Refund' || payment.group == 'Void' ? '(-' + this.calculationService.roundOff(payment.amount) + ')' || 0 : this.calculationService.roundOff(payment.amount) || 0,
        'Order amount': this.calculationService.roundOff(estimate.total.grand) || 0,
        'Remaining amount': this.calculationService.roundOff(payment.remainingAmount) || 0,
        Note: payment?.refunds && payment?.refunds?.notes ? payment?.refunds?.notes : payment?.notes || 'N/A',
        // paymentSubType: `${payment.isCreditPayment ? `${payment.paymentMethod.name} (${payment.paymentMethod.code})` : payment.paymentMethod.name}`,
      };

      return _payment;
    });
  }

  customerInspectionsFormat(inspections: any[]) {
    return inspections.map((inspection: any) => ({
      shopId: inspection.shopId,
      inspection: inspection.title ? inspection : 'Untitled',
      dateTime: this.dateService.getCurrentDateTimeTz(new Date(inspection.createdAt).getTime()),
      estimate: inspection.estimateId ? inspection.estimateId : 'Untitled',
      category: inspection.category ? inspection.category : {},
      condition: inspection.category ? this.setInspectionItemsCounts(inspection) : {},
    }));
  }

  setInspectionItemsCounts(inspection: any) {
    if (inspection && inspection.category && inspection.category.length) {
      this.counts = this.helperService.deepCopy(this.defaultCount);
      this.counts.categories = inspection.category.length;
      inspection.category.forEach((category: any) => {
        if (category.inspectionItems.length) {
          this.counts.items += category.inspectionItems.length;
          category.inspectionItems.forEach(({ attachments, colorIndex }: any) => {
            if (colorIndex === -1) {
              this.counts.condition.notInspected += 1;
            } else {
              this.counts.condition[inspectionItemColorIndex[colorIndex]] += 1;
            }
          });
        }
      });
      return this.counts;
    }

    this.categoryItemText = `
    ${this.counts.categories} ${this.counts.categories > 1 ? 'categories' : 'category'}
    ${this.counts.items} ${this.counts.items > 1 ? 'items' : 'item'}
    `;
  }

  logsListFormat(logs: any[]) {
    return logs.map((log: any) => ({
      _id: log._id,
      date: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
      module: log.moduleName ? log.moduleName : '',
      title: log.title ? log.title : 'Untitled',
      description: this.helperService.removeTagsFromString(log.text || ''),
      actionBy: log.actionBy,
    }));
  }

  formatSalesTrendReportList(sales: any[]) {
    const isRevenueRecognitionSettleEnabled = this.dataService.isRevenueRecognitionSettleEnabled;
    return sales.map((sale: any) => ({
      _id: sale._id,
      shopId: sale.shopId,
      finalizeDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(sale.finalizeDate).getTime()), datetimeFormat.listD),
      finalizeType: sale.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[sale.finalizeType]} ${sale.thirdPartyAccount || ''}` : this.finalizeTypeLabel[sale.finalizeType] || '',
      invoiceDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(sale.invoiceDate).getTime()), datetimeFormat.listD),
      createdBy: (sale.serviceWriter && sale.serviceWriter.name) || '',
      title: `${sale.code} - ${sale.title || config.defaultTitle}`,
      invCode: sale.orderStatus === 'invoice' ? sale.invCode || sale.code || '' : '',
      customer: (sale.customer && sale.customer.displayName) || '',
      companyName: (sale.customer && sale.customer.companyName) || '',
      customerType: (sale.customer && sale.customer.customerType) || '',
      vehicle: sale.vehicle && sale.vehicle.name ? sale.vehicle.name : '',
      payment: sale.isPaidFull ? 'Fully paid' : sale.isPaidPartial ? 'Partially paid' : 'Unpaid',
      taxableAmt: sale.total.taxableAmount || 0,
      nonTaxableAmount: sale.total.nonTaxableAmount || 0,
      taxAmt: sale.total.taxedAmount || 0,
      passThroughTax: sale.total && sale.total.passThroughTax ? sale.total.passThroughTax : 0,
      total: sale.total && sale.total.grand ? sale.total.grand : 0,
    }));
  }

  formatSalesTrendReportExport(array: any[]) {
    const data = [];
    const isRevenueRecognitionSettleEnabled = this.dataService.isRevenueRecognitionSettleEnabled;
    array.map((e) => {
      if (e._id) {
        const paymentAmount = e.card + e.cash + e.cheque + e.creditPayment + e.thirdParty;
        const remainingAmount = e.total.grand - paymentAmount;

        let laborPrice = 0;
        let partsPrice = 0;
        let other = 0;

        let paymentStatus = 'Unpaid';
        if (e.isPaidFull) {
          paymentStatus = 'Fully paid';
        } else if (e.isPaidPartial) {
          paymentStatus = 'Partially paid';
        }

        if (e && e.service && e.service.length) {
          e.services.forEach((s) => {
            laborPrice += s.summary.totalLaborPrice;
            partsPrice += s.summary.totalPartsPrice;
            other += s.summary.totalOtherPrice;
          });
        }

        data.push({
          finalizeDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.finalizeDate).getTime()), datetimeFormat.exportFormatD),
          'Invoice date': this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.invoiceDate).getTime()), datetimeFormat.exportFormatD),
          finalizeType: e.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[e.finalizeType]} ${e.thirdPartyAccount || ''}` : this.finalizeTypeLabel[e.finalizeType] || '',
          Order: `${e.code} - ${e.title}`,
          'Invoice #': e.orderStatus === 'invoice' ? e.invCode || e.code || '' : '',
          shopId: e.shopId,
          'Service advisor': (e.serviceWriter && e.serviceWriter.name) || '',
          Customer: e.customer && e.customer.fullName ? e.customer.fullName : '',
          Company: (e.customer && e.customer.companyName) || '',
          Vehicle: e.vehicle && e.vehicle.name ? e.vehicle.name : '',
          'Order amount': e.total && e.total.grand ? e.total.grand : 0,
          'Labor amount': e.total && e.total.labor ? e.total.labor : 0,
          'Tire amount': e.total && e.total.tire ? e.total.tire : 0,
          'Sublet amount': e.total && e.total.sublet ? e.total.sublet : 0,
          'Tire storage amount': e.total && e.total.tireStorage ? e.total.tireStorage : 0,
          'Service level fees': e.total && e.total.hazmatFee ? e.total.hazmatFee : 0,
          'RO level fees': e.total && e.total.totalFee ? e.total.totalFee : 0,
          'Parts amount': e.total && e.total.parts ? e.total.parts : 0,
          'Other amount': e.total && e.total.other ? e.total.other : 0,
          'Sales Tax': e.total && e.total.taxedAmount ? this.calculationService.roundOff(e.total.taxedAmount) : 0,
          'Passthrough Tax': e.total && e.total.passThroughTax ? e.total.passThroughTax : 0,
          'Total discount': (e.total && e.total.discountedAmount ? e.total.discountedAmount : 0) + (e.total && e.total.itemDiscountedAmount ? e.total.itemDiscountedAmount : 0),
          'Customer type': e.firstOrder ? 'New customer' : 'Repeat customer',
          'Amount remaining': remainingAmount || 0,
          'RO#': e.code,
          'Payment status': paymentStatus,
          'Payment amount': paymentAmount || 0,
        });
      }
    });
    return data;
  }

  formatProfitabilityReportList(roList: any[]) {
    return roList.map((ro: any) => {
      ro.title = `RO # ${ro.code}: ${ro.title}`;
      ro.location = `Hill Road`;
      // ro.invCode = ro.orderStatus === 'invoice' ? ro.invCode || ro.code || '' : '';
      ro.invCode = ro.invCode;
      (ro.createdBy = (ro.serviceWriter && ro.serviceWriter.name) || ''), (ro.companyName = (ro.customer && ro.customer.companyName) || '');
      ro.customerType = (ro.customer && ro.customer.customerType) || '';
      ro.customer = ro.customer && ro.customer.displayName ? ro.customer.displayName : '';
      ro.payment = ro.isPaidFull ? 'Fully paid' : ro.isPaidPartial ? 'Partially paid' : 'Unpaid';
      ro.partPrice = this.calculationService.roundOff(ro.partPrice);
      ro.partCost = this.calculationService.roundOff(ro.partCost);
      ro.laborPrice = this.calculationService.roundOff(ro.laborPrice);
      ro.laborCost = this.calculationService.roundOff(ro.laborCost);
      ro.tirePrice = this.calculationService.roundOff(ro.tirePrice);
      ro.tireCost = this.calculationService.roundOff(ro.tireCost);
      ro.hazmatFeePrice = this.calculationService.roundOff(ro.hazmatFeePrice || 0);
      ro.hazmatFeeCost = this.calculationService.roundOff(ro.hazmatFeeCost || 0);
      ro.serviceLevelDiscount = this.calculationService.roundOff(ro.serviceLevelDiscount || 0);
      return ro;
    });
  }

  formatProfitabilityReportExport(array: any[]) {
    const data = [];
    array.map((ro) => {
      if (ro._id) {
        data.push({
          'RO#': `RO# ${ro.code}`,
          Order: `RO # ${ro.code}: ${ro.title}`,
          shopId: ro.shopId,
          'Invoice #': ro.orderStatus === 'invoice' ? ro.invCode || ro.code || '' : '',
          'Service advisor': (ro.serviceWriter && ro.serviceWriter.name) || '',
          Customer: ro.customer && ro.customer.displayName ? ro.customer.displayName : '',
          'Payment status': ro.isPaidFull ? 'Fully paid' : ro.isPaidPartial ? 'Partially paid' : 'Unpaid',
          Company: (ro.customer && ro.customer.companyName) || '',
          'RO Price': this.calculationService.roundOff(ro.totalPrice),
          'RO Cost': this.calculationService.roundOff(ro.totalCost),
          'RO Margin': `${this.calculationService.roundOff(Number((ro && ro.totalMargin) || 0) * 100)}%`,
          'Part Price': this.calculationService.roundOff(ro.partPrice),
          'Part Cost': this.calculationService.roundOff(ro.partCost),
          'Part Margin': `${this.calculationService.roundOff(ro.partMargin * 100)}%`,
          'Labor Price': this.calculationService.roundOff(ro.laborPrice),
          'Labor Cost': this.calculationService.roundOff(ro.laborCost),
          'Labor Margin': `${this.calculationService.roundOff(ro.laborMargin * 100)}%`,
          'Tire Price': this.calculationService.roundOff(ro.tirePrice),
          'Tire Cost': this.calculationService.roundOff(ro.tireCost),
          'Tire Margin': `${this.calculationService.roundOff(ro.tireMargin * 100)}%`,
          'Sublet Price': this.calculationService.roundOff(ro?.subletPrice || 0),
          'Sublet Cost': this.calculationService.roundOff(ro?.subletCost || 0),
          'Sublet Margin': `${this.calculationService.roundOff((ro?.subletMargin || 0) * 100)}%`,
          'Tire Storage Price': this.calculationService.roundOff(ro.tireStoragePrice),
          'Tire Storage Cost': this.calculationService.roundOff(ro.tireStorageCost),
          'Tire Storage Margin': `${this.calculationService.roundOff(ro.tireStorageMargin * 100)}%`,
          'Other Price': this.calculationService.roundOff(ro.otherPrice),
          'Other Cost': this.calculationService.roundOff(ro.otherCost),
          'Other Margin': `${this.calculationService.roundOff(ro.otherMargin * 100)}%`,
          'Fees Price': this.calculationService.roundOff(ro.hazmatFeePrice),
          'Fees Cost': this.calculationService.roundOff(ro.hazmatFeeCost),
          'Fees Margin': `${this.calculationService.roundOff(ro.hazmatFeeMargin * 100)}%`,
          'Order Discount': `${this.calculationService.roundOff(ro.totalDiscount)}`,
          // 'Order Taxes': this.calculationService.roundOff(ro.totalTax),
          'Parts line discount': this.calculationService.roundOff(ro.partLineLevelDiscount),
          'Labor line discount': this.calculationService.roundOff(ro.laborLineLevelDiscount),
          'Tire line discount': this.calculationService.roundOff(ro.tireLineLevelDiscount),
          'Tire storage line discount': this.calculationService.roundOff(ro.tireStorageLineLevelDiscount),
          'Other line discount': this.calculationService.roundOff(ro.otherLineLevelDiscount),
          'RO line discount': this.calculationService.roundOff(ro.totalLineLevelDiscount),
          'Shop Supplies': this.calculationService.roundOff(ro.serviceCharges),
        });
      }
    });
    return data;
  }

  formatCannedServiceReportList(services: any[], serviceBillableHours: any[]) {
    const _serviceBillableHour = {};

    serviceBillableHours.forEach((service) => {
      _serviceBillableHour[service._id] = service.billedHours;
    });

    return services.map((service, index) => ({
      _id: service.categoryId,
      title: service._id,
      location: 'Hill road',
      category: service.category,
      count: service.count,
      workedHours: this.calculationService.roundOff(service.workedHours),
      billedHours: this.calculationService.roundOff(_serviceBillableHour[service._id]),
      partsMargin: `${this.currencyPipe.transform(service.partsValue || 0)} (${this.calculateMarginUpdateFormula(service.partPrice, service.partCost)})`,
      laborMargin: `${this.currencyPipe.transform(service.laborValue || 0)} (${this.calculateMarginUpdateFormula(service.laborPrice, service.laborCost)})`,
      totalCost: this.calculationService.roundOff(service.totalCost),
      totalPrice: this.calculationService.roundOff(service.totalPrice),
      totalProfit: this.calculationService.roundOff(service.totalProfit),
      tiresMargin: `${this.currencyPipe.transform(service.tireValue || 0)} (${this.calculateMarginUpdateFormula(service.tirePrice, service.tireCost)})`,
      subletsMargin: `${this.currencyPipe.transform(service?.subletValue || 0)} (${this.calculateMarginUpdateFormula(service?.subletPrice || 0, service?.subletCost || 0)})`,
      tiresStorageMargin: `${this.currencyPipe.transform(service.tireStorageValue || 0)} (${this.calculateMarginUpdateFormula(service.tireStoragePrice, service.tireStorageCost)})`,
      otherMargin: `${this.currencyPipe.transform(service.otherValue || 0)} (${this.calculateMarginUpdateFormula(service.otherPrice, service.otherCost)})`,
      feeMargin: `${this.currencyPipe.transform(service.feeValue || 0)} (${this.calculateMarginUpdateFormula(service.feePrice, service.feeCost)})`,
      avgPrice: `${this.currencyPipe.transform(service.average || 0)}`,
      grossMargin: `${this.calculationService.roundOff(service.grossMargin)}%`,
      serviceLevelDiscount: `${this.currencyPipe.transform(service.serviceLevelDiscount || 0)}`,
    }));
  }

  formatCannedServiceDetailsReportExport(reports: any[]) {
    const data = [];
    return reports.map((e: any) => {
      let totals = {
        price: 0,
        cost: 0,
      };
      let dataToPush = {
        'Invoice date': this.dateService.formatDate(e.invoiceDate, datetimeFormat.listD) || '',
        'Invoice #': e.invCode || '',
        'RO #': e.roNumber || '',
        shopId: e?.shopId || '',
        'Parts margin': this.getMarginValueForServiceInvoiced(e.services, 'part', totals),
        'Labor margin': this.getMarginValueForServiceInvoiced(e.services, 'labor', totals),
        'Tire margin': this.getMarginValueForServiceInvoiced(e.services, 'tire', totals),
        'Tire storage margin': this.getMarginValueForServiceInvoiced(e.services, 'tireStorage', totals),
        'Sublet margin': this.getMarginValueForServiceInvoiced(e.services, 'sublet', totals),
        'Other margin': this.getMarginValueForServiceInvoiced(e.services, 'other', totals),
        'Fee margin': this.getMarginValueForServiceInvoiced(e.services, 'hazmatFee', totals),
        // 'Avg price': `$${this.calculationService.roundOff(e.grossaverageMargin)}`,
        grossMargin: '',
        totalCost: '',
        totalPrice: '',
        totalProfit: '',
        serviceLevelDiscount: '',
      };

      if (this.dataService.isRevenueRecognitionSettleEnabled) {
        dataToPush['finalizeDate'] = this.dateService.formatDate(e.finalizeDate, datetimeFormat.exportFormatD);
        dataToPush['finalizeType'] = e.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[e.finalizeType]} ${e.thirdPartyAccount || ''}` : this.finalizeTypeLabel[e.finalizeType];
      } else {
        dataToPush['Invoice date'] = this.dateService.formatDate(e.invoiceDate, datetimeFormat.exportFormatD);
      }

      dataToPush.totalCost = this.currencyPipe.transform(totals.cost);
      dataToPush.totalPrice = `$${totals.price}`;
      dataToPush.totalProfit = this.currencyPipe.transform(totals.price - totals.cost);
      dataToPush.grossMargin = `${this.calculationService.roundOff(((totals.price - totals.cost) * 100) / totals.price || 0)}%`;
      (dataToPush.serviceLevelDiscount = `${this.currencyPipe.transform((e.services && e.services.serviceTotal.serviceLevelDiscount) || 0)}`), data.push(dataToPush);
      return dataToPush;
    });
  }

  reportsCannedServiceDetailFormat(array: any) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        let totals = {
          price: 0,
          cost: 0,
        };
        let dataToPush = {
          _id: e._id,
          title: e.services && e.services.title ? e.services.title : '',
          customer: e.customer && e.customer.fullName ? e.customer.fullName : '',
          // vehicle: e.vehicle && e.vehicle.name ? e.vehicle.name : '',
          // technician: e.services && e.services.tech && e.services.tech.name ? e.services.tech.name : 'N/A',
          // workedHours: e.services.summary.totalWorkedHours,
          // billedHours: totalBillableHours,
          // partsMargin: this.calculateMargin(totalPartsPrice, totalPartsCost),
          // laborMargin: this.calculateMargin(totalLaborPrice, totalLaborCost),
          // totalCost: Math.round(totalLaborCost + totalPartsCost),
          // totalPrice: Math.round(totalPartsPrice + totalLaborPrice),
          // totalProfit: Math.round(totalPartsPrice + totalLaborPrice - (totalLaborCost + totalPartsCost)),

          invoiceDate: this.dateService.formatDate(e.invoiceDate, datetimeFormat.listD),
          finalizeDate: this.dateService.formatDate(e.finalizeDate, datetimeFormat.listD),
          finalizeType: e.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[e.finalizeType]} ${e.thirdPartyAccount || ''}` : this.finalizeTypeLabel[e.finalizeType] || '',
          invoice: e.invCode || '',
          roNumber: e.roNumber || '',
          shopId: e?.shopId || '',
          partsMargin: this.getMarginValueForServiceInvoiced(e.services, 'part', totals),
          laborMargin: this.getMarginValueForServiceInvoiced(e.services, 'labor', totals),
          tireMargin: this.getMarginValueForServiceInvoiced(e.services, 'tire', totals),
          tireStorageMargin: this.getMarginValueForServiceInvoiced(e.services, 'tireStorage', totals),
          subletMargin: this.getMarginValueForServiceInvoiced(e.services, 'sublet', totals),
          otherMargin: this.getMarginValueForServiceInvoiced(e.services, 'other', totals),
          feeMargin: this.getMarginValueForServiceInvoiced(e.services, 'hazmatFee', totals),
          serviceLevelDiscount: e.services && e.services.serviceTotal.serviceLevelDiscount,
          grossMargin: '',
          totalCost: 0,
          totalPrice: 0,
          totalProfit: 0,
        };
        dataToPush.totalCost = totals.cost;
        dataToPush.totalPrice = e.services.serviceTotal.netTotal;
        dataToPush.totalProfit = totals.price - totals.cost;
        dataToPush.grossMargin = `${this.calculationService.roundOff((dataToPush.totalProfit * 100) / totals.price)}%`;
        data.push(dataToPush);
      }
    });
    return data;
  }

  getMarginValueForServiceInvoiced(service, type, total) {
    //discounted price =line item price - Apportioned service discount - Apportioned order discount
    // Apportioned service discount = (service level discount value * line item price) /  Service total
    // Apportioned order discount  = (order level discount value * line item price) /  RO total
    // item margin = (discounted price - cost)/ discounted price * 100
    // line item value = line item price - line item cost - Apportioned service discount - Apportioned order discount;
    if (service && service.serviceTotal) {
      const itemPrice = (service.serviceTotal[type] || 0) - (service.serviceTotal.itemTypeDiscount[type] || 0);
      const itemCost = service.totalCost[type] || 0;
      const appServiceDiscount = (service.serviceTotal.serviceLevelDiscount * itemPrice) / service.serviceTotal.netTotal || 0;
      const appOrderDiscount = (service.orderLevelDiscount * itemPrice) / service.roTotal || 0;
      const priceWithoutDiscount = itemPrice - appServiceDiscount - appOrderDiscount;
      const itemValue = priceWithoutDiscount - itemCost;
      total.price += priceWithoutDiscount;
      total.cost += itemCost;
      return `${this.currencyPipe.transform(itemValue || 0, currency.USD)} (${this.calculateMarginUpdateFormula(priceWithoutDiscount, itemCost)})`;
    }
    return `$0 (0)`;
  }

  formatOutstandingInvoiceReportExport(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        const paymentAmount = e.card + e.cash + e.cheque + e.creditPayment + e.thirdParty + e.writeOff;
        const remainingAmount = e.total.grand - paymentAmount;
        data.push({
          _id: e._id,
          shopId: e.shopId,
          'Invoiced Date': this.dateService.formatDate(e.invoiceDate, datetimeFormat.exportFormatD),
          finalizeDate: e.finalizeDate ? this.dateService.formatDate(e.finalizeDate, datetimeFormat.listD) : '-',
          finalizeType: e.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[e.finalizeType]} ${e.thirdPartyAccount || ''}` : this.finalizeTypeLabel[e.finalizeType || ''],
          Customer: e.customer && e.customer.fullName ? e.customer.fullName : '',
          Company: (e.customer && e.customer.companyName) || '',
          Vehicle: e.vehicle && e.vehicle.name ? e.vehicle.name : '',
          'Workflow status': e.workFlowStatus && e.workFlowStatus.name ? e.workFlowStatus.name : '',
          'Archive status': e.isArchived ? 'Archived' : 'Not archived',
          Order: e.title ? `${e.code} - ${e.title}` : '',
          'Invoice #': e.orderStatus === 'invoice' ? e.invCode || e.code || '' : '',
          'Order amount': e.total && e.total.grand ? e.total.grand : 0,
          'Payment amount': paymentAmount,
          'Remaining amount': remainingAmount,
        });
      }
    });
    return data;
  }

  formatOutstandingInvoiceReportList(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        const paymentAmount = e.card + e.cash + e.cheque + e.creditPayment + e.thirdParty + e.writeOff ;
        const remainingAmount = e.total.grand - paymentAmount;
        data.push({
          _id: e._id,
          shopId: e.shopId,
          finalizeDate: e.finalizeDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.finalizeDate).getTime()), datetimeFormat.listD) : '-',
          invoiceDate: e.invoiceDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.invoiceDate).getTime()), datetimeFormat.listD) : '',
          finalizeType: e.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[e.finalizeType]} ${e.thirdPartyAccount || ''}` : this.finalizeTypeLabel[e.finalizeType || ''],
          location: 'Hill Road',
          companyName: (e.customer && e.customer.companyName) || '',
          customer: (e.customer && e.customer.displayName) || '',
          vehicle: e.vehicle && e.vehicle.name ? e.vehicle.name : '',
          workflowStatus: e.workFlowStatus && e.workFlowStatus.name ? e.workFlowStatus.name : '',
          archiveStatus: e.isArchived ? 'Archived' : 'Not archived',
          order: e.title ? `${e.code} - ${e.title}` : '',
          invCode: e.orderStatus === 'invoice' ? e.invCode || e.code || '' : '',
          orderAmount: e.total && e.total.grand ? e.total.grand : 0,
          paymentAmount: paymentAmount,
          remainingAmount: remainingAmount,
        });
      }
    });

    return data;
  }

  formatAPSupplierReportList(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id && e.supplier) {
        data.push({
          _id: e._id || null,
          supplier: e.supplier,
          type: e.type,
          unpaidPos: e?.unpaidPos || 0,
          paidPos: e?.paidPos || 0,
          notDue: `${this.calculationService.roundOff(e.notDue || 0)}`,
          firstMonth: `${this.calculationService.roundOff(e.firstMonth || 0)}`,
          secondMonth: `${this.calculationService.roundOff(e.secondMonth || 0)}`,
          moreThanTwoMonths: `${this.calculationService.roundOff(e.MoreThanTwoMonths || 0)}`,
          total: `${this.calculationService.roundOff(e.total || 0)}`,
        });
      }
    });
    return data;
  }

  formatAPSupplierReportDetailList(array: any[], openingBalance) {
    const data = [];
    let initOpeningBalance = openingBalance;
    let initRunningBalance = initOpeningBalance;
    array.map((e) => {
      initRunningBalance = e.activityType === 'itemDelivered' ? initRunningBalance + e.amount : initRunningBalance - e.amount;
      data.push({
        activityDate: e.activityDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.activityDate).getTime()), datetimeFormat.listD) : '',
        activityType: activityTypeSupplierOrder[e.activityType],
        amount: `${this.calculationService.roundOff(e.amount || 0)}`,
        showFormatedAmount: e.activityType === 'itemDelivered' ? `$${this.calculationService.roundOff(e.amount || 0)}` : `($${this.calculationService.roundOff(e.amount || 0)})`,
        code: e.code,
        id: e._id || '',
        type: e.type || '',
        objectId: e.objectId || '',
        sourceId: e.sourceId || '',
        orderingMethod: e.orderingMethod || '',
        runningBalance: `${this.calculationService.roundOff(initRunningBalance || 0)}`,
      });
    });
    return data;
  }

  formatAPSupplierReportDetailListSubletVersion(array: any[], openingBalance) {
    const data = [];
    let initOpeningBalance = openingBalance;
    let initRunningBalance = initOpeningBalance;
    array.map((e) => {
      initRunningBalance = e.activityType === 'completed' ? initRunningBalance + e.amount : initRunningBalance - e.amount;
      data.push({
        activityDate: e.activityDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.activityDate).getTime()), datetimeFormat.listD) : '',
        activityType: activityTypeSupplierOrderSublet[e.activityType],
        amount: `${this.calculationService.roundOff(e.amount || 0)}`,
        showFormatedAmount: e.activityType === 'completed' ? `$${this.calculationService.roundOff(e.amount || 0)}` : `($${this.calculationService.roundOff(e.amount || 0)})`,
        code: e.code,
        id: e._id || '',
        type: e.type || '',
        objectId: e.objectId || '',
        sourceId: e.sourceId || '',
        orderingMethod: e.orderingMethod || '',
        runningBalance: `${this.calculationService.roundOff(initRunningBalance || 0)}`,
        name: e?.name || '',
      });
    });
    return data;
  }

  getPaymentStatus(payableStatus: number): string {
    if (payableStatus === 0) {
      return 'Due today';
    } else if (payableStatus < 0) {
      return 'Overdue';
    } else if (payableStatus > 0) {
      return 'Due Soon';
    } else {
      return '-';
    }
  }
  formatAccountsReceivableReportList(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        data.push({
          customer: e.customer || e.customerFirstName || '',
          type: e.isFleetCustomer ? 'Fleet' : 'Regular',
          chargeAccountEnable: e.chargeAccountEnable || false,
          firstMonth: e.firstMonth || 0,
          secondMonth: e.secondMonth || 0,
          thirdMonth: e.thirdMonth || 0,
          MoreThanThreeMonths: e.MoreThanThreeMonths || 0,
          total: e.total || 0,
          invoices: e.invoices || 0,
          unpaidStatements: e.unpaidStatements || '-',
          lastStatementSent: e.lastStatementSent ? this.dateService.formatDate(e.lastStatementSent, datetimeFormat.listD) : '-',
          phone: this.formatPhoneNumber(e.phone && e.phone.toString()) || '',
          email: e.email || '',
          customerId: e._id || '',
        });
      }
    });
    return data;
  }

  formatTechSummaryReportList(techSummary: any[], isSplitFlag: boolean = false, efficiency: any[] = []) {
    let formattedData = techSummary.map((summary) => {
      const matchingEfficiency = efficiency.find((eff) => eff._id === summary._id) || {};
      return {
        _id: summary._id,
        name: summary.name,
        Role: summary.role || 'Primary',

        singleTechServices: `${summary.singleServicesTech || 0}`,
        multiTechServices: `${summary.multiServicesTech || 0}`,

        // Billable hours
        billableTotalHours: isSplitFlag
          ? `${this.calculationService.roundOff(summary.updatedBillableHour.totalBillableHours || 0)}`
          : `${this.calculationService.roundOff(summary.billableHours.totalHours || 0)}`,
        billableTotalCost: isSplitFlag
          ? `$${this.calculationService.roundOff(summary.updatedBillableHour.totalCost || 0)}`
          : `$${this.calculationService.roundOff(summary.billableHours.totalCost || 0)}`,
        billableApprovedHours: isSplitFlag
          ? `${this.calculationService.roundOff(summary.updatedBillableHour.approvedHours || 0)}`
          : `${this.calculationService.roundOff(summary.billableHours.approvedHours || 0)}`,
        billableApprovedCost: isSplitFlag
          ? `$${this.calculationService.roundOff(summary.updatedBillableHour.approvedCost || 0)}`
          : `$${this.calculationService.roundOff(summary.billableHours.approvedCost || 0)}`,

        // Estimated hours
        estimatedTotalHours: isSplitFlag
          ? `${this.calculationService.roundOff(summary.updatedEstimatedHour.totalEstimatedHour || 0)}`
          : `${this.calculationService.roundOff(summary.estimatedHours.totalHours || 0)}`,
        estimatedTotalCost: isSplitFlag
          ? `$${this.calculationService.roundOff(summary.updatedEstimatedHour.totalCost || 0)}`
          : `$${this.calculationService.roundOff(summary.estimatedHours.totalCost || 0)}`,
        estimatedApprovedHours: isSplitFlag
          ? `${this.calculationService.roundOff(summary.updatedEstimatedHour.approvedHours || 0)}`
          : `${this.calculationService.roundOff(summary.estimatedHours.approvedHours || 0)}`,
        estimatedApprovedCost: isSplitFlag
          ? `$${this.calculationService.roundOff(summary.updatedEstimatedHour.approvedCost || 0)}`
          : `$${this.calculationService.roundOff(summary.estimatedHours.approvedCost || 0)}`,

        // Actual hours
        actualTotalHours: `${this.calculationService.roundOff(summary.actualWorkedHours.totalHours || 0)}`,
        actualTotalCost: `$${this.calculationService.roundOff(summary.actualWorkedHours.totalCost || 0)}`,
        actualApprovedHours: `${this.calculationService.roundOff(summary.actualWorkedHours.approvedHours || 0)}`,
        actualApprovedCost: `$${this.calculationService.roundOff(summary.actualWorkedHours.approvedCost || 0)}`,

        // Chart Data
        efficiency: `${this.calculationService.roundOff(matchingEfficiency.efficiency || 0)}%`,
        productivity: `${this.calculationService.roundOff(matchingEfficiency.productivity || 0)}%`,
        // clockHours: this.calculationService.roundOff(matchingEfficiency.clockHours || 0),
      };
    });

    // console.log('formattedData', formattedData)

    // Add total row (only for export)
    if (formattedData.length > 0) {
      let totalRow = this.getTotalRow(formattedData);
      formattedData.push(totalRow);
    }

    return formattedData;
  }

  getTotalRow(data: any[]): any {
    let totalRow: any = { name: 'Total', className: 'total' };

    const sumFields = [
      'singleTechServices',
      'multiTechServices',
      'billableTotalHours',
      'billableTotalCost',
      'billableApprovedHours',
      'billableApprovedCost',
      'estimatedTotalHours',
      'estimatedTotalCost',
      'estimatedApprovedHours',
      'estimatedApprovedCost',
      'actualTotalHours',
      'actualTotalCost',
      'actualApprovedHours',
      'actualApprovedCost',
      // 'efficiency',
      // 'productivity'
    ];

    sumFields.forEach((field) => {
      let sum = data.reduce((total, row) => {
        let value = row[field] || '0';

        // Remove currency signs
        if (typeof value === 'string') {
          value = value.replace(/\$/g, '');
        }

        return total + (parseFloat(value) || 0);
      }, 0);

      if (field.includes('Cost') || field.includes('Price')) {
        totalRow[field] = `$${this.calculationService.roundOff(sum)}`;
      }
      // else if (field === 'efficiency' || field === 'productivity') {
      //   totalRow[field] = `${this.calculationService.roundOff(sum)}%`;
      // }
      else {
        totalRow[field] = this.calculationService.roundOff(sum);
      }
    });
    return totalRow;
  }

  formatTechSummaryReportByAllServiceList(techSummary: any[]) {
    return techSummary.map((summary) => {
      // if (summary._id) {
      return {
        _id: summary._id,
        name: summary.name,
        technicianRole: summary.role || 'Primary',

        // Estimated hours
        estimatedTotalHours: `${this.calculationService.roundOff(summary.estimatedHours.totalHours)}`,
        estimatedTotalCost: `$${this.calculationService.roundOff(summary.estimatedHours.totalCost || 0)}`,
        estimatedApprovedHours: `${this.calculationService.roundOff(summary.estimatedHours.approvedHours)}`,
        estimatedApprovedCost: `$${this.calculationService.roundOff(summary.estimatedHours.approvedCost || 0)}`,

        // Billable hours
        billableTotalHours: `${this.calculationService.roundOff(summary.billableHours.totalHours)}`,
        billableTotalCost: `$${this.calculationService.roundOff(summary.billableHours.totalCost || 0)}`,
        billableApprovedHours: `${this.calculationService.roundOff(summary.billableHours.approvedHours)}`,
        billableApprovedCost: `$${this.calculationService.roundOff(summary.billableHours.approvedCost || 0)}`,
      };
      // }
    });
  }

  formatTechSummaryReportExport(techSummary: any[], isSplitFlag = false) {
    return techSummary.map((summary) => {
      if (summary._id) {
        return {
          _id: summary._id,
          Technician: summary.name,
          singleServicesTech: `${summary.singleServicesTech || 0}`,
          multiServicesTech: `${summary.multiServicesTech || 0}`,
          Role: summary.role || 'Primary',

          // Estimated hours
          estimatedTotalHours: `${this.calculationService.roundOff(isSplitFlag ? summary.updatedEstimatedHour.totalEstimatedHour || 0 : summary.estimatedHours.totalHours)}`,
          estimatedTotalCost: `$${this.calculationService.roundOff(summary.estimatedHours.totalCost || 0)}`,
          estimatedApprovedHours: `${this.calculationService.roundOff(summary.estimatedHours.approvedHours)}`,
          estimatedApprovedCost: `$${this.calculationService.roundOff(summary.estimatedHours.approvedCost || 0)}`,

          // Billable hours
          billableTotalHours: `${this.calculationService.roundOff(isSplitFlag ? summary.updatedBillableHour.totalBillableHours || 0 : summary.billableHours.totalHours)}`,
          billableTotalCost: `$${this.calculationService.roundOff(summary.billableHours.totalCost || 0)}`,
          billableApprovedHours: `${this.calculationService.roundOff(summary.billableHours.approvedHours)}`,
          billableApprovedCost: `$${this.calculationService.roundOff(summary.billableHours.approvedCost || 0)}`,

          // Actual hours
          ActualTotalHours: `${this.calculationService.roundOff(summary.actualWorkedHours.totalHours)}`,
          ActualTotalCost: `$${this.calculationService.roundOff(summary.actualWorkedHours.totalCost || 0)}`,
          ActualApprovedHours: `${this.calculationService.roundOff(summary.actualWorkedHours.approvedHours)}`,
          ActualApprovedCost: `$${this.calculationService.roundOff(summary.actualWorkedHours.approvedCost || 0)}`,

          // Efficiency: this.calculationService.calculateTechEfficiency(summary.hoursBilled, summary.hoursService),
        };
      }
    });
  }

  formatTechSummaryAllServicesReportExport(techSummary: any[]) {
    return techSummary.map((summary) => {
      // if (summary._id) {
      return {
        _id: summary._id,
        Technician: summary.name,
        Role: summary.role || 'Primary',

        // estimatedTotalCost: `${this.calculationService.roundOff(summary.estimatedHours.approvedHours)} ($${this.calculationService.roundOff(summary.estimatedHours.approvedCost || 0)})`,

        // Estimated hours
        estimatedTotalHours: `${this.calculationService.roundOff(summary.estimatedHours.totalHours || 0)}`,
        estimatedTotalCost: `$${this.calculationService.roundOff(summary.estimatedHours.totalCost || 0)}`,
        estimatedApprovedHours: `${this.calculationService.roundOff(summary.estimatedHours.approvedHours || 0)}`,
        estimatedApprovedCost: `$${this.calculationService.roundOff(summary.estimatedHours.approvedCost || 0)}`,

        // Billable hours
        billableTotalHours: `${this.calculationService.roundOff(summary.billableHours.totalHours || 0)}`,
        billableTotalCost: `$${this.calculationService.roundOff(summary.billableHours.totalCost || 0)}`,
        billableApprovedHours: `${this.calculationService.roundOff(summary.billableHours.approvedHours)}`,
        billableApprovedCost: `$${this.calculationService.roundOff(summary.billableHours.approvedCost || 0)}`,
        // ActualTotalHours: `${this.calculationService.roundOff(summary.actualWorkedHours.totalHours)} ($${this.calculationService.roundOff(summary.actualWorkedHours.totalCost || 0)})`,
        // ActualApprovedHours: `${this.calculationService.roundOff(summary.actualWorkedHours.approvedHours)} ($${this.calculationService.roundOff(summary.actualWorkedHours.approvedCost || 0)})`,
        // Efficiency: this.calculationService.calculateTechEfficiency(summary.hoursBilled, summary.hoursService),
      };
      // }
    });
  }

  formatTechSummaryAllServicesDrillDownReportExport(techSummary: any[]) {
    const shopsMap = this.dataService.shopsMap;
    return techSummary.map((summary) => {
      // if (summary._id && summary.roCode) {
      return {
        technician: summary.employeeName || '',
        RO: summary.roCode,
        customer: summary.customer.fullName,
        invoiceDate: summary.invoiceDate,
        finalizeDate: summary.finalizeDate,
        finalizeType:
          summary.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[summary.finalizeType]} ${summary.thirdPartyAccount || ''}` : this.finalizeTypeLabel[summary.finalizeType || ''],
        service: summary.service.name,
        status: summary.service.serviceStatus,
        workedHours: `${this.calculationService.roundOff(summary.service.service || 0)}`,
        techCost: summary.service.techCost,
        billableHours: `${this.calculationService.roundOff(summary.service.billableHours || 0)}`,
        estimatedHours: `${this.calculationService.roundOff(summary.service.estimatedHours.totalHours || 0)}`,
        efficiency: summary.service.efficiency,
        billedAmount: summary.service.billedAmount,
        role: summary.employeeRole,
        shopId: (shopsMap[summary?.shopId] && shopsMap[summary?.shopId].shopName) || '',
      };
      // }
    });
  }

  reportsTechDetailFormat(array) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        data.push({
          _id: e._id,
          activityType: e.workType === 'service' ? 'Service' : 'Inspection',
          activityName: e.title,
          // Need to fix it.
          // startTime: this.dateService.dateFormathmma(e.start),
          // endTime: this.dateService.dateFormathmma(e.end),
          pauses: e.pauses - 1,
          workedHours: e && e.summary && e.summary.hoursWorked ? this.calculationService.roundOff(e.summary.hoursWorked) : 0,
          rate: e && e.summary && e.summary.totalLaborCost && e.summary.totalBillableHours ? this.calculateTechRate(e.summary.totalLaborCost, e.summary.totalBillableHours) : 0,
          title: e.orderTitle,
          hoursBilled: e && e.summary && e.summary.totalBillableHours ? this.calculationService.roundOff(e.summary.totalBillableHours) : 0,
          totalCost: e && e.summary && e.summary.totalLaborCost && e.summary.totalPartsCost ? this.calculationService.roundOff(e.summary.totalLaborCost + e.summary.totalPartsCost) : 0,
        });
      }
    });
    return data;
  }

  formatTechLogsReportList(array: any) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        data.push({
          _id: e._id,
          shopId: e.shopId,
          start: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.start).getTime()), datetimeFormat.listDT),
          location: 'Hill road',
          technician: `${e.employee.firstName} ${e.employee.lastName}`,
          technicianRole: ['helper1', 'helper2'].includes(e.role) ? 'Helper' : 'Primary',
          code: e.order.code,
          title: e.order.title,
          activityType: e.workType === 'service' ? 'Service' : 'Inspection',
          activityName: e.title,
          activityStatus: e.action,
          customer: e.order && e.order.customer && e.order.customer.fullName ? e.order.customer.fullName : '',
          vehicle: e.order && e.order.vehicle && e.order.vehicle.displayName ? e.order.vehicle.displayName : '',
          orderId: e.orderId,
        });
      }
    });
    return data;
  }

  formatTechLogsReportExport(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        data.push({
          _id: e._id,
          shopId: e.shopId,
          'Time & date': this.dateService.formatDate(e.start, datetimeFormat.mmmdyyhhmmaa),
          Technician: `${e.employee.firstName} ${e.employee.lastName}`,
          Role: e.role || 'Primary',
          'Order No': e.order.code,
          'Order name': e.order.title,
          'Activity type': e.workType === 'service' ? 'Service' : 'Inspection',
          'Activity name': e.title,
          'Activity status': e.action,
          Customer: e.order && e.order.customer && e.order.customer.fullName ? e.order.customer.fullName : '',
          Vehicle: e.order && e.order.vehicle && e.order.vehicle.displayName ? e.order.vehicle.displayName : '',
        });
      }
    });
    return data;
  }

  formateTenantList(tenants: any[]) {
    return tenants.map(({ _id, name, companyType, subscription, isMarkDelete, golive, shopCount, appsettings }) => ({
      _id,
      name,
      isMarkDelete,
      golive,
      shopCount,
      status: subscription ? 'Active' : 'Inactive',
      companyType: this.helperService.companyTypeToTitleMap(companyType),
      ...appsettings,
      appsettings,
    }));
  }

  formatTaxesForReport(taxGroups: any[] = []) {
    const taxes = [];

    if (taxGroups && taxGroups.length) {
      taxGroups.forEach((taxCode: any) => {
        let unassingedTaxCode = taxCode.taxGroupTotalTax || 0;
        taxes.push({
          id: taxCode._id,
          type: 'taxCode',
          taxCodeId: taxCode._id,
          grossAmount: this.calculationService.roundOff(taxCode.totalGrossAmt || 0),
          taxableAmount: this.calculationService.roundOff(taxCode.totalTaxableAmt || 0),
          nonTaxableAmount: this.calculationService.roundOff(taxCode.totalNonTaxableAmt || 0),
          percentage: this.calculationService.roundOff(taxCode.taxGroupPercentage || 0),
          taxRateName: taxCode.taxGroupName === 'Pass Through Tax' ? `Passthrough Tax` : `${taxCode.taxGroupName} (${this.calculationService.roundOff(taxCode.taxGroupPercentage || 0)}%)`,
          taxedAmount: this.calculationService.roundOff(taxCode.taxGroupTotalTax || 0),
          totalGrossAmount: this.calculationService.roundOff((taxCode.taxGroupTotalTax || 0) + (taxCode.totalTaxableAmt || 0) + (taxCode.totalNonTaxableAmt || 0)),
        });
        if (taxCode.taxGroupName === 'Tax Exempt') {
          taxes.push({
            type: 'taxRate',
            id: 'unassigned',
            taxCodeId: 'Tax exempt',
            grossAmount: taxCode.totalGrossAmt || 0,
            taxedAmount: taxCode.totalTax || 0,
            percentage: 0,
            taxableAmount: 0,
            taxRatePercentage: 0,
            nonTaxableAmount: 0,
            taxRateName: `${taxCode.taxGroupName} (0%)`,
          });
        }
        if (taxCode.taxRatesGroup && taxCode.taxRatesGroup.length) {
          taxCode.taxRatesGroup.forEach((taxRate: any) => {
            unassingedTaxCode -= taxRate.totalTaxRateAmt || 0;
            taxes.push({
              type: 'taxRate',
              isSubLineItem: true,
              id: taxRate.taxRateId,
              taxCodeId: taxCode._id,
              grossAmount: taxRate.taxRateGrossAmt || 0,
              taxedAmount: taxRate.totalTaxRateAmt || 0,
              percentage: taxRate.taxRatePercentage || 0,
              taxableAmount: taxRate.taxRateTaxableAmt || 0,
              taxRatePercentage: taxRate.taxRatePercentage || 0,
              nonTaxableAmount: taxRate.taxRateNonTaxableAmt || 0,
              taxGroupName: taxCode.taxGroupName,
              taxRateName: taxCode.taxGroupName === 'Pass Through Tax' ? `${taxRate.taxRateName}` : `${taxRate.taxRateName} (${this.calculationService.roundOff(taxRate.taxRatePercentage || 0)}%)`,
            });
          });
        }
        if (this.calculationService.roundOff(unassingedTaxCode) > 0 && taxCode.taxGroupName !== 'Pass Through Tax') {
          taxes.push({
            id: '',
            type: 'taxRate',
            taxCodeId: taxCode._id,
            isSubLineItem: true,

            grossAmount: taxCode.unAssignedTotalGrossAmt || 0,
            taxedAmount: unassingedTaxCode,
            taxableAmount: taxCode.unAssignedTaxableAmt || 0,
            nonTaxableAmount: taxCode.unAssignedTotalNonTaxableAmt || 0,
            taxRateName: `Unassigned tax rate`,
          });
        }
      });
    }

    const taxHeader = {
      type: 'taxTotal',
      taxRateName: 'Total',
      grossAmount: 0,
      nonTaxableAmount: 0,
      taxableAmount: 0,
      taxedAmount: 0,
    };

    taxes.forEach(({ taxedAmount, grossAmount, taxableAmount, nonTaxableAmount, type }) => {
      if (type === 'taxCode') {
        taxHeader.taxedAmount += this.calculationService.roundOff(taxedAmount || 0);
        taxHeader.nonTaxableAmount += this.calculationService.roundOff(nonTaxableAmount || 0);
        taxHeader.taxableAmount += this.calculationService.roundOff(taxableAmount || 0);
        taxHeader.grossAmount = this.calculationService.roundOff(taxHeader.taxedAmount + taxHeader.nonTaxableAmount + taxHeader.taxableAmount);
      }
    });
    taxes.splice(0, 0, taxHeader);

    return taxes;
  }

  formatTaxRatesForReport(data: any[] = []) {
    const taxRates = [];
    data.forEach((order) => {
      const taxRate: any = {
        code: order.code,
        finalizeDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(order.finalizeDate).getTime()), datetimeFormat.ddmmyyyy),
        finalizeType: order.finalizeType === 'thirdPartyAccounts' ? `${this.finalizeTypeLabel[order.finalizeType]} ${order.thirdPartyAccount || ''}` : this.finalizeTypeLabel[order.finalizeType || ''],
        invCode: order.invCode,
        orderStatus: order.orderStatus === 'estimate' ? 'Estimate' : 'Invoice',
        paymentStatus: '',
        invoiceDate: '',
        taxAmount: 0,
        taxPercentage: 0,
        taxRateAmount: 0,
        taxRatePercentage: 0,
        taxCodeId: '',
        taxCodeName: '',
        taxRateId: '',
        taxRateName: '',
        orderId: order.orderId,
        shopId: order?.shopId || '',
      };

      if (order.isPaidFull) {
        taxRate.paymentStatus = 'Paid';
      } else {
        taxRate.paymentStatus = order.isPaidPartial ? 'Partially paid' : 'Unpaid';
      }

      if (order.invoiceDate) {
        taxRate.invoiceDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(order.invoiceDate).getTime()), datetimeFormat.mmmdyyyy);
      }

      if (order.total) {
        if (order.total.tax) {
          taxRate.taxPercentage = this.calculationService.roundOff(order.total.tax.value || 0);
          taxRate.taxCodeId = order.total.tax.id;
          taxRate.taxCodeName = order.total.tax.name;
        }

        taxRate.taxAmount = this.calculationService.roundOff(order.total.taxedAmount);
      }

      if (order.taxValues && order.taxValues.taxRates) {
        taxRate.taxRateId = order.taxValues.taxRates.taxId;
        taxRate.taxRateName = order.taxValues.taxRates.name;
        taxRate.taxRateAmount = this.calculationService.roundOff(order.taxValues.taxRates.taxAmount);
        taxRate.taxRatePercentage = this.calculationService.roundOff(order.taxValues.taxRates.salesTaxRate);
      } else if (order.type === 'unassigned') {
        taxRate.taxRateId = '';
        taxRate.taxRateName = order?.total?.tax.id ? 'Unassigned' : order?.total?.tax?.name;
        taxRate.taxRateAmount = this.calculationService.roundOff(order.total.taxedAmount);
        taxRate.taxRatePercentage = this.calculationService.roundOff(order.total.tax && order.total.tax.value);
      }

      taxRates.push(taxRate);
    });
    return taxRates;
  }

  formatOrderReportList(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        let paymentStatus = 'Unpaid';
        if (e.isPaidFull) {
          paymentStatus = 'Fully paid';
        } else if (e.isPaidPartial) {
          paymentStatus = 'Partially paid';
        }

        let laborPrice = (e.total && e.total.labor) || 0;
        let partsPrice = (e.total && e.total.parts) || 0;
        let tirePrice = (e.total && e.total.tire) || 0;
        let other = (e.total && e.total.other) || 0;
        let shopFees = (e.total && e.total.shopFee) || 0;
        let totalFee = (e.total && e.total.totalFee) || 0;
        let tireStoragePrice = (e.total && e.total.tireStorage) || 0;

        data.push({
          _id: e._id,
          code: e.code,
          shopId: e.shopId,
          title: e.title,
          order: `${e.code} - ${e.title}` || '',
          location: 'Hill Road',
          invCode: e.orderStatus === 'invoice' ? e.invCode || e.code || '' : '',
          customer: e.customer && e.customer.displayName ? e.customer.displayName : '',
          companyName: e.customer && e.customer.companyName ? e.customer.companyName : '',
          customerType: e.customer && e.customer.customerType ? e.customer.customerType : '',
          customerEmail: e.customer && e.customer.email ? e.customer.email : '',
          customerPhone: e.customer && e.customer.phone ? e.customer.phone : '',
          vehicle: e.vehicle && e.vehicle.vehicleId && e.vehicle.vehicleId.name ? e.vehicle.vehicleId.name : '',
          vin: e.vehicle && e.vehicle.vehicleId && e.vehicle.vehicleId.VIN ? e.vehicle.vehicleId.VIN : 'N/A',
          createdAt: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.backdatedCreationDate || e.createdAt).getTime()), datetimeFormat.listD),
          invoiceDate: e.orderStatus === 'invoice' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.invoiceDate).getTime()), datetimeFormat.listD) : 'N/A',
          lastPayment: e.lastPayment ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(e.lastPayment).getTime()), datetimeFormat.listD) : 'N/A',
          paymentStatus: paymentStatus,
          orderStatus: e.orderStatus === 'estimate' ? 'Estimate' : 'Invoice',
          workflowStatus: e.workFlowStatus && e.workFlowStatus.name ? e.workFlowStatus.name : '',
          laborPrice: laborPrice,
          partsPrice: partsPrice,
          other: other,
          tire: tirePrice,
          tireStorage: tireStoragePrice,
          tax: e.total && e.total.taxedAmount ? e.total.taxedAmount : 0,
          passThroughTax: e.total && e.total.passThroughTax ? e.total.passThroughTax : 0,
          serviceCharges: shopFees,
          totalFee: totalFee,
          discount: e.total && e.total.discountedAmount ? e.total.discountedAmount : 0,
          totalPaid: e.card + e.cash + e.cheque + e.creditPayment + e.thirdParty + e.writeOff || 0,
          totalOrderAmount: e.total && e.total.grand ? e.total.grand : 0,
          hazmatFee: e.total && e.total.hazmatFee ? e.total.hazmatFee : 0,
          itemDiscountedAmount: e.total && e.total.itemLevelDiscount ? e.total.itemLevelDiscount : 0,
          serviceLevelDiscount: (e.total && e.total.serviceLevelDiscount) || 0,
        });
      }
    });

    return data;
  }

  formatStatementList(array: any[]) {
    const statements = [];

    array.forEach((statement) => {
      if (statement.sendDate) {
        statement.sendDate = this.dateService.getCurrentDateTimeTz(new Date(statement.sendDate).getTime());
      }

      statement.createdAt = this.dateService.getCurrentDateTimeTz(new Date(statement.createdAt).getTime());

      statements.push(statement);
    });

    return statements;
  }

  formatCustomerStatementList(array: any[]) {
    array.forEach((statement) => {
      if (statement.sendDate) {
        statement.sendDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(statement.sendDate).getTime()), datetimeFormat.listD);
      }

      statement.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(statement.createdAt).getTime()), datetimeFormat.listD);
      if (statement?.customer) {
        (statement.customerName = statement?.customer?.fullName),
          (statement.contact = {
            _id: statement?.customer._id,
            isFleetCustomer: statement?.customer.isFleetCustomer,
            contactOnEmail: statement?.customer.contactOnEmail,
            contactOnPhone: statement?.customer.contactOnPhone,
            email: statement?.customer?.email,
            phone: statement?.customer?.phone,
            name: statement?.customer?.fullName,
            isEditing: false,
            displayContact: statement?.customer.contactOnEmail
              ? statement?.customer?.email
              : statement?.customer?.contactOnPhone
                ? statement?.customer?.phone
                : statement?.customer?.email || statement?.customer?.phone,
          });
      }
    });

    return array;
  }

  formatCustomerBulkStatementList(data: any[]) {
    let _bulkStatement = [];

    let currentDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date().getTime()), datetimeFormat.yyyymmmdd);
    data.map((item: any) => {
      if (item.partOfStatement && item.name) {
        let statementName = `${item.name}_${currentDate}`;
        _bulkStatement.push({
          name: item?.name,
          newInvoiceCount: item?.newStatement?.count,
          statementName,
          newTotal: `${this.currencyPipe.transform(item?.newStatement?.total || 0)}`,
          newUnpaid: `${this.currencyPipe.transform(item?.newStatement?.unpaid || 0)}`,
          previousInvoiceCount: item?.partOfStatement?.count,
          previousTotalAmount: `${this.currencyPipe.transform(item?.partOfStatement?.total || 0)}`,
          previousUnpaid: `${this.currencyPipe.transform(item?.partOfStatement?.unpaid || 0)}`,
          _id: item?._id,
          bulkNewInvoices: item?.newStatement?.invoices || [],
          bulkPreviousInvoices: item?.newStatement?.invoices.concat(item?.partOfStatement?.invoices) || [],
          newInvoices: item?.newStatement?.invoices && item?.newStatement?.invoices?.length ? item?.newStatement?.invoices?.map((obj) => obj.invoiceId) : [],
          previousInvoices: item?.partOfStatement?.invoices && item?.partOfStatement?.invoices?.length ? item?.partOfStatement?.invoices?.map((obj) => obj.invoiceId) : [],
          _rawItem: item,
          customer: item?.customer,
          showMoveInvice: {
            newInvoiceCount: (item?.newStatement?.count || 0) + (item?.partOfStatement?.count || 0),
            newTotal: `${this.currencyPipe.transform((item?.partOfStatement?.total || 0) + (item?.newStatement?.total || 0))}`,
            newUnpaid: `${this.currencyPipe.transform((item?.partOfStatement?.unpaid || 0) + (item?.newStatement?.unpaid || 0))}`,
          },
        });
      }
    });
    return _bulkStatement;
  }

  formatOrderReportExport(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        let paymentStatus = 'Unpaid';
        if (e.isPaidFull) {
          paymentStatus = 'Fully paid';
        } else if (e.isPaidPartial) {
          paymentStatus = 'Partially paid';
        }

        let laborPrice = (e.total && e.total.labor) || 0;
        let partsPrice = (e.total && e.total.parts) || 0;
        let tirePrice = (e.total && e.total.tire) || 0;
        let tireStoragePrice = (e.total && e.total.tireStorage) || 0;
        let other = (e.total && e.total.other) || 0;
        let shopFees = (e.total && e.total.shopFee) || 0;
        let fees = (e.total && e.total.hazmatFee) || 0;
        let [createdAt, invoicedAt, lastPaymentAt] = [e.createdAt, e.invoiceDate, e.lastPayment].map((date) => {
          if (date) {
            return this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(date).getTime()), datetimeFormat.exportFormatD);
          }

          return '';
        });

        data.push({
          _id: e._id,
          Order: `${e.code} - ${e.title}`,
          shopId: e.shopId,
          'Invoice #': e.orderStatus === 'invoice' ? e.invCode || e.code || '' : '',
          Customer: e.customer && e.customer.fullName ? e.customer.fullName : '',
          Company: e.customer && e.customer.companyName ? e.customer.companyName : '',
          Vehicle: e.vehicle && e.vehicle.vehicleId && e.vehicle.vehicleId.name ? e.vehicle.vehicleId.name : '',
          VIN: e.vehicle && e.vehicle.vehicleId && e.vehicle.vehicleId.VIN ? e.vehicle.vehicleId.VIN : 'N/A',
          'Date created': createdAt,
          'Date invoiced': invoicedAt,
          'Last payment posted': lastPaymentAt,
          'Payment status': paymentStatus,
          'Order status': e.orderStatus === 'estimate' ? 'Estimate' : 'Invoice',
          'Workflow status': e.workFlowStatus && e.workFlowStatus.name ? e.workFlowStatus.name : '',
          'Labor price': laborPrice,
          'Parts price': partsPrice,
          'Tire price': tirePrice,
          'Tire storage price': tireStoragePrice,
          'Shop supplies': shopFees,
          Other: other,
          Tax: e.total && e.total.taxedAmount ? this.calculationService.roundOff(e.total.taxedAmount) : 0,
          'Passthrough Tax': e.total && e.total.passThroughTax ? this.calculationService.roundOff(e.total.passThroughTax) : 0,
          'Item discount': e.total && e.total.itemDiscountedAmount ? e.total.itemDiscountedAmount : 0,
          'Order discount': e.total && e.total.discountedAmount ? e.total.discountedAmount : 0,
          'Service discount': e.total && e.total.serviceLevelDiscount ? e.total.serviceLevelDiscount : 0,
          'Total paid': e.card + e.cash + e.cheque + e.creditPayment + e.thirdParty,
          'Total order amount': e.total && e.total.grand ? e.total.grand : 0,
          Fee: fees,
          'RO Fee': e.total && e.total.totalFee ? e.total.totalFee : 0,
        });
      }
    });
    return data;
  }

  formatCustomerReportList(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        const totalPayments = sum([
          this.calculationService.roundOff(e.totalCard),
          this.calculationService.roundOff(e.totalCash),
          this.calculationService.roundOff(e.totalCheque),
          this.calculationService.roundOff(e.totalCreditPayment),
          this.calculationService.roundOff(e.totalThirdParty),
        ]);

        data.push({
          _id: e._id,
          customer: e.displayName || '',
          customerType: e.customerType,
          companyName: e.companyName || '',
          email: e.email ? e.email : 'N/A',
          mobile: e.phone ? e.phone : '',
          createdAt: this.dateService.formatDate(e.createdAt, datetimeFormat.listD),
          vehicles: e.vehicles && e.vehicles.length ? e.vehicles.length : 0,
          totalSales: e.totalSales ? Number(e.totalSales).toFixed(2) : 0,
          totalPayments: totalPayments ? Number(totalPayments).toFixed(2) : 0,
          outstandingPayments: Number(e.totalSales - totalPayments).toFixed(2),
        });
      }
    });
    return data;
  }

  formatReviewReportList(reports: any[]) {
    return reports.map((report: any) => {
      const _report = {
        _id: report._id,
        shopId: report?.shopId,
        time: this.dateService.formatDate(report.reviewTime, datetimeFormat.listDT),
        customer: (report.customer && report.customer.fullName) || '',
        location: '',
        title: (report.estimate && report.estimate.title) || '',
        review: report.feedback || '',
        rating: report.rating || 0,
        technician: '',
        shopResponse: (report.reviewReply && report.reviewReply.comment) || 'N/A',
        responseTime: report.reviewReply && report.reviewReply.updateTime ? this.dateService.formatDate(report.reviewReply.updateTime, datetimeFormat.listDT) : 'N/A',
      };

      return _report;
    });
  }

  formatPricingMatrixList(data: any) {
    // name: 'Regular Customer Pricing', value: 'regular' , showSelected: 'Regular Customer Pricing'
    return data.map((matrix, index) => {
      return {
        name: matrix.name,
        value: matrix.type === 'custom' ? `${matrix.type}-${index}` : matrix.type,
        showSelected: matrix.name,
        pricingRuleId: matrix.pricingRuleId || null,
        type: matrix.type || '',
      };
    });
  }

  formatTireConnectData(data: any, baseTireId: string): any[] {
    let fomrattedArray: any[] = [];

    const { tire, currentTime } = data;

    if (tire?.length) {
      tire.forEach((tire: any) => {
        const supplier = {
          ...tire,
          name: tire?.supplier?.nice_name,
          labelName: tire?.supplier?.name,
          numericItemId: tire.tire_id,
          price: tire?.price,
          cost: tire?.cost,
          hasStock: tire?.is_in_stock,
          partNumber: tire?.part_number_original,
          locations: [],
          quantity: tire?.quantity,
        };

        tire?.branches?.forEach((branch: any) => {
          let estimatedDeliveryDay: string = '';

          if (branch.estimated_delivery_date) {
            const deliveryDays = moment(new Date(branch.estimated_delivery_date)).diff(moment(currentTime), 'days');
            if (deliveryDays) {
              estimatedDeliveryDay = `${deliveryDays} working days`;
            } else {
              estimatedDeliveryDay = `Same day`;
            }
          }

          supplier.locations.push({
            supplier: {
              id: tire?.supplier?.name,
              name: tire?.supplier?.nice_name,
            },
            numericItemId: tire.tire_id,
            warehouseId: branch.id,
            name: branch.name,
            estimatedDeliveryDay: estimatedDeliveryDay,
            totalAvailable: branch.quantity,
            count: 0,
            cost: tire.cost,
            price: tire.price,
            baseTireId,
            isPrimary: branch?.branch_type === 'primary',
          });
        });

        fomrattedArray.push(supplier);
      });
    }
    return fomrattedArray;
  }

  formatReviewsReportExport(reports: any[]) {
    return reports.map((report: any) => {
      const _report = {
        _id: report._id,
        'Time & Date': this.dateService.formatDate(report.reviewTime, datetimeFormat.exportFormatD),
        'Customer name': (report.customer && report.customer.fullName) || '',
        Title: (report.estimate && report.estimate.title) || '',
        Review: report.feedback || '',
        Rating: report.rating || 0,
        Technician: '',
        Response: (report.reviewReply && report.reviewReply.comment) || 'N/A',
        'Response time': report.reviewReply && report.reviewReply.updateTime ? this.dateService.formatDate(report.reviewReply.updateTime, datetimeFormat.exportFormatD) : 'N/A',
      };

      return _report;
    });
  }

  formatInternalReviewsReportExport(array: any[]) {
    const data = [];
    array.map((e) => {
      if (e._id) {
        data.push({
          _id: e._id,
          'Time & Date': this.dateService.formatDate(e.reviewTime, datetimeFormat.mmmdyyhhmmaa),
          'Customer name': e.customer && e.customer.fullName ? e.customer.fullName : '',
          'Order name': e.estimate && e.estimate.title ? e.estimate.title : '',
          Review: e.feedback ? e.feedback : '',
          Rating: e.rating ? e.rating : '',
          Technician: '',
          Response: e.reviewReply && e.reviewReply.comment ? e.reviewReply.comment : 'N/A',
          'Response time': e.reviewReply && e.reviewReply.updateTime ? this.dateService.formatDate(e.reviewReply.updateTime, datetimeFormat.exportFormatD) : 'N/A',
        });
      }
    });
    return data;
  }

  formatCannedServiceReportExport(reports: any[]) {
    return reports.map((report: any) => {
      try {
        const _report = {
          'Canned service': report._id || '',
          Category: report.category || '',
          '# Sold': report.count || 0,
          'Total hours worked': report.workedHours || `${0}`,
          'Total hours billed': report.billedHours || `${0}`,
          'Parts margin': `${this.currencyPipe.transform(report.partsValue || 0)}  (${this.calculateMarginUpdateFormula(report.partPrice, report.partCost || `(${0}%)`)})`,
          'Labor margin': `${this.currencyPipe.transform(report.laborValue || 0)} (${this.calculateMarginUpdateFormula(report.laborPrice, report.laborCost) || `(${0}%)`})`,

          'Tire margin': `${this.currencyPipe.transform(report.tireValue || 0)} (${this.calculateMarginUpdateFormula(report.tirePrice, report.tireCost) || 0})`,
          'Sublet margin': `${this.currencyPipe.transform(report?.subletValue || 0)} (${this.calculateMarginUpdateFormula(report?.subletPrice || 0, report?.subletCost || 0) || 0})`,
          'Tire storage margin': `${this.currencyPipe.transform(report.tireStorageValue || 0)} (${this.calculateMarginUpdateFormula(report.tireStoragePrice, report.tireStorageCost) || 0})`,
          'Other margin': `${this.currencyPipe.transform(report.otherValue || 0)} (${this.calculateMarginUpdateFormula(report.otherPrice, report.otherCost) || 0})`,
          'Fee margin': `${this.currencyPipe.transform(report.feeValue || 0)} (${this.calculateMarginUpdateFormula(report.feePrice, report.feeCost) || 0})`,
          'Avg price': `${this.currencyPipe.transform(report.average || 0)}`,

          'Total cost': `${this.currencyPipe.transform(report.totalCost || 0)}`,
          'Total price': `${this.currencyPipe.transform(report.totalPrice || 0)}`,
          'Total profit': `${this.currencyPipe.transform(report.totalProfit || 0)}`,
          'Service discount': `${this.currencyPipe.transform(report.serviceLevelDiscount || 0)}`,
          'Gross margin': `${this.calculationService.roundOff(report.grossMargin || 0)}%`,
        };

        return _report;
      } catch (err) {
        console.log(report);
        console.log(err);

        return {};
      }
    });
  }

  removePhoneFormatting(str: string) {
    if (str) {
      str = str.trim();
      str = str.replace(/\D+/g, '');
    }

    return str;
  }

  formatPhoneNumber(str: string) {
    if (!str) {
      return str;
    }

    const phone = this.removePhoneFormatting(str);

    if (phone.length >= 10) {
      const phoneArr = phone.split('');

      return `(${phoneArr.slice(0, 3).join('')}) ${phoneArr.slice(3, 6).join('')}-${phoneArr.slice(6).join('')}`;
    }

    return phone;
  }

  calculateMargin(price, cost) {
    const margin = Math.round(((price - cost) / price) * 100);
    if (isNaN(margin)) {
      return `0%`;
    } else {
      return `${margin.toFixed(2)}%`;
    }
  }

  calculateMarginUpdateFormula(price, cost) {
    if (!price) {
      return `0%`;
    }
    const margin = this.calculationService.roundOff((1 - cost / price) * 100);
    if (isNaN(margin)) {
      return `0%`;
    } else {
      return `${margin.toFixed(2)}%`;
    }
  }
  calculateTechRate(laborCost, hoursBilled) {
    const rate = laborCost / hoursBilled;
    if (isNaN(rate) || !isFinite(rate)) {
      return 0;
    } else {
      return rate;
    }
  }

  highlightedPartstechText(text, query, isGlobal = true) {
    if (text && query) {
      query = this.toTitleCase(query);
      let str = text.replace(/\s/g, ' ');
      let searchTerm = query.replace(/[^a-zA-Z0-9 ]/g, '');
      const terms = searchTerm.split(' ');

      const regex = new RegExp(`(${terms.join('|').replace(/\s/g, ' ')})`, `i${isGlobal ? 'g' : ''}`);

      str = str.replace(regex, '<span class="highlighted-text-gs">$1</span>');

      str = str.replace(/<\/span> <span class="highlighted-text-gs">/g, ' ');

      return str;
    }
    return text;
  }

  highlighedSearchText(text: string, query: string) {
    if (text && query) {
      let str = text.replace(/\s/g, '&nbsp;');
      query = query.replace(/[^a-zA-Z0-9 ]/g, '');
      const regex = new RegExp(`(${query.replace(/\s/g, '&nbsp;')})`);
      str = str.replace(regex, `<span class="font-600"><b>$1</b></span>`);
      return str;
    }
    return text;
  }

  highlighedSearchTextEnhancement(text: string, query: string, isGlobal: boolean = true) {
    if (text && query) {
      let str = text.replace(/\s/g, '&nbsp;');
      let searchTerm = query.replace(/\s/g, '&nbsp;');
      const regex = new RegExp(`(${searchTerm})`, `i${isGlobal ? 'g' : ''}`);
      str = str.replace(regex, `<span class="font-600"><b>${searchTerm}</b></span>`);
      return str;
    }
    return text;
  }

  makeCategoryText(category: any[]) {
    const categories = [];

    if (category && category.length) {
      category.forEach((cat: any) => {
        categories.push(cat.title);
      });

      return categories.join(', ');
    }

    return categories;
  }

  makeScheduleFollowUpData(data: any, customer: any) {
    const payload = {
      type: data.type,
      title: data.campaignTitle,
      campaignId: data.campaignId,
      marketingTemplate: data.marketingTemplate,
      isSendToPrimaryOnly: data.isSendToPrimaryOnly,
      scheduleAt: this.dateService.formatDate(data.scheduleAt, datetimeFormat.yyymmddhhmm),
      followUpEvent: data.followUpEvent,
      customer: {
        customerId: customer._id,
        displayName: customer.fullNameQBO,
        email: customer.email,
        phone: customer.phone,
      },
      order: {},
      vehicle: {},
    };

    if (data.order && data.order.orderId) {
      payload.order = data.order;
    }

    if (data.vehicle && data.vehicle.vehicleId) {
      payload.vehicle = {
        vehicleId: data.vehicle.vehicleId,
        name: data.vehicle.name,
      };
    }

    return payload;
  }

  toTitleCase = (phrase) => {
    return phrase
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  formatCustomerVehicleFollowUp(data: any[], customer: any, serverTime = Date.now(), contact: any) {
    const recommendedFollowUps = [];
    const eligibleFollowUps = [];
    const { companyName: shopName, companyPhone: shopContact } = this.helperService.getCompany();
    const primary: any = { email: {}, phone: {} };

    if (contact && contact.contactInfo && contact.contactInfo.length) {
      contact.contactInfo.forEach((contact: any) => {
        if (contact.isPrimary) {
          if (contact.contactType === 'email') {
            primary.email = contact;
          } else {
            primary.phone = contact;
          }
        }
      });
    }

    data.forEach(({ _id, title, followUpSentAfter, followUpEvent, vehicle, type, marketingTemplate, isSendToPrimaryOnly, isRecommended }) => {
      const parseData: any = {
        shopName,
        shopContact,
        lastName: customer.lastName,
        firstName: customer.firstName,
        customerCreatedAt: this.dateService.getCurrentDateTimeTz(new Date(customer.createdAt).getTime()),
      };

      const followUp = {
        type,
        matchId: '',
        followUpEvent,
        vehicle: null,
        campaignId: _id,
        campaignTitle: title,
        contacts: [],
        unsubscribeCount: 0,
        contactTooltip: '',
        isSendToPrimaryOnly: isSendToPrimaryOnly,
        contact: type === 'EMAIL' ? customer.email : customer.phone,
        scheduleAt: this.dateService.addDaysInDatetime(new Date(serverTime), (followUpSentAfter && followUpSentAfter.noOfDays) || 1, 'day', null, false),
        marketingTemplate: marketingTemplate,
        customerId: customer._id,
      };

      if (contact && contact.contactInfo && contact.contactInfo.length) {
        if (type === 'EMAIL') {
          if (isSendToPrimaryOnly && primary.email.value) {
            followUp.contacts = [primary.email.value];

            if (primary.email.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
          } else if (!isSendToPrimaryOnly) {
            contact.contactInfo.forEach((contact: any) => {
              if (contact.isActive && contact.contactType === 'email') {
                followUp.contacts.push(contact.value);

                if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
              }
            });
          }
        } else if (type === 'SMS') {
          if (isSendToPrimaryOnly && primary.phone.value) {
            followUp.contacts = [primary.phone.value];

            if (primary.phone.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
          } else if (!isSendToPrimaryOnly) {
            contact.contactInfo.forEach((contact: any) => {
              if (contact.isActive && ['mobile', 'landline'].includes(contact.contactType)) {
                followUp.contacts.push(contact.value);

                if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
              }
            });
          }
        }
      }

      if (followUp.contacts && followUp.contacts.length) {
        followUp.contactTooltip = `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
          ${type === 'EMAIL' ? 'Email' : 'SMS'}
          </div>

          ${(followUp.contacts || [])
            .map(
              (contact: string) =>
                `<div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
            <i class="fal fa-${type === 'EMAIL' ? 'envelope' : 'mobile'} font-gray-65 mt-1"></i>
            <span class="truncate" style="width: 160px;">${contact}</span>
          </div>`,
            )
            .join('')}

            ${
              followUp.unsubscribeCount
                ? `<div class="tooltip-secondary-row font-12 font-orange py-0 mt-1">
              <span>${followUp.unsubscribeCount} ${type === 'EMAIL' ? 'email' : 'phone'} opted out</span>
            </div>`
                : ''
            }
        </div>
      `;
      }

      if (followUpEvent === followUpEvents.VEHICLE_SAVE) {
        followUp.vehicle = { vehicleId: vehicle._id, name: vehicle.name };
        followUp.matchId = `${followUp.campaignId}-${followUp.vehicle.vehicleId}`;
        parseData.vehicleCreatedAt = this.dateService.getCurrentDateTimeTz(new Date(vehicle.createdAt).getTime());
        parseData.vehicleName = vehicle.name;
      } else {
        followUp.matchId = `${followUp.campaignId}-${customer._id}`;
      }

      if (followUp.marketingTemplate) {
        followUp.marketingTemplate.defaultText = followUp.marketingTemplate.text;
        followUp.marketingTemplate.text = this.helperService.mktTemplateParser(parseData, followUp.marketingTemplate?.text);
      }

      if (followUpEvent === followUpEvents.VEHICLE_SAVE) {
        if (vehicle.isRecommended) {
          recommendedFollowUps.push(followUp);
        } else {
          eligibleFollowUps.push(followUp);
        }
      } else {
        if (isRecommended) {
          recommendedFollowUps.push(followUp);
        } else {
          eligibleFollowUps.push(followUp);
        }
      }
    });

    return { recommendedFollowUps, eligibleFollowUps };
  }

  formatOrderFollowUp(data: any[], customer: any, serverTime = Date.now(), contact: any) {
    const recommendedFollowUps = [];
    const eligibleFollowUps = [];
    const { companyName: shopName, companyPhone: shopContact } = this.helperService.getCompany();
    const primary: any = { email: {}, phone: {} };

    if (contact && contact.contactInfo && contact.contactInfo.length) {
      contact.contactInfo.forEach((contact: any) => {
        if (contact.isPrimary) {
          if (contact.contactType === 'email') {
            primary.email = contact;
          } else {
            primary.phone = contact;
          }
        }
      });
    }

    data.forEach(({ _id, title, followUpSentAfter, followUpEvent, followUps: order, type, marketingTemplate, isSendToPrimaryOnly, isRecommended }) => {
      if (!order) return;

      let parseData: any = {
        shopName,
        shopContact,
      };

      if (customer) {
        parseData.lastName = customer.lastName;
        parseData.firstName = customer.firstName;
        parseData.customerCreatedAt = parseData.customerCreatedAt ? this.dateService.getCurrentDateTimeTz(new Date(customer.createdAt).getTime()) : '';
        parseData.contact = type === 'EMAIL' ? customer.email : this.helperService.formatPhoneNumber(customer.phone);
      }

      const followUp = {
        type,
        matchId: '',
        order: null,
        vehicle: null,
        followUpEvent,
        contacts: [],
        campaignTitle: title,
        campaignId: _id.campaignId,
        contactTooltip: '',
        unsubscribeCount: 0,
        isSendToPrimaryOnly: isSendToPrimaryOnly,
        contact: parseData.contact,
        scheduleAt: this.dateService.addDaysInDatetime(new Date(serverTime), followUpSentAfter.noOfDays, 'day', null, false),
        marketingTemplate: marketingTemplate,
        customerId: customer._id,
      };

      if (order) {
        followUp.vehicle = {
          vehicleId: order.vehicleId,
          name: order.vehicleName,
        };

        followUp.order = {
          code: order.code,
          title: order.title,
          orderId: order.orderId,
          invCode: order.invCode,
          shopNotes: order.shopNotes,
          invoiceDate: null,
          sendEstimate: null,
        };

        followUp.matchId = `${followUp.campaignId}-${followUp.order.orderId}`;

        if (order.invoiceDate) {
          followUp.order.invoiceDate = this.dateService.getCurrentDateTimeTz(new Date(order.invoiceDate).getTime());
        }

        if (order.sendEstimate) {
          followUp.order.sendEstimate = this.dateService.getCurrentDateTimeTz(new Date(order.sendEstimate).getTime());
        }

        parseData = {
          ...parseData,
          ...followUp.order,
          vehicleName: order.vehicleName,
        };
      }

      if (contact && contact.contactInfo && contact.contactInfo.length) {
        if (type === 'EMAIL') {
          if (isSendToPrimaryOnly && primary.email.value) {
            followUp.contacts = [primary.email.value];

            if (primary.email.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
          } else if (!isSendToPrimaryOnly) {
            contact.contactInfo.forEach((contact: any) => {
              if (contact.isActive && contact.contactType === 'email') {
                followUp.contacts.push(contact.value);

                if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
              }
            });
          }
        } else if (type === 'SMS') {
          if (isSendToPrimaryOnly && primary.phone.value) {
            followUp.contacts = [primary.phone.value];

            if (primary.phone.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
          } else if (!isSendToPrimaryOnly) {
            contact.contactInfo.forEach((contact: any) => {
              if (contact.isActive && ['mobile', 'landline'].includes(contact.contactType)) {
                followUp.contacts.push(contact.value);

                if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
              }
            });
          }
        }
      }

      if (followUp.contacts && followUp.contacts.length) {
        followUp.contactTooltip = `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
          ${type === 'EMAIL' ? 'Email' : 'SMS'}
          </div>

          ${(followUp.contacts || [])
            .map(
              (contact: string) =>
                `<div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
            <i class="fal fa-${type === 'EMAIL' ? 'envelope' : 'mobile'} font-gray-65 mt-1"></i>
            <span class="truncate" style="width: 160px;">${contact}</span>
          </div>`,
            )
            .join('')}

            ${
              followUp.unsubscribeCount
                ? `<div class="tooltip-secondary-row font-12 font-orange py-0 mt-1">
              <span>${followUp.unsubscribeCount} ${type === 'EMAIL' ? 'email' : 'phone'} opted out</span>
            </div>`
                : ''
            }
        </div>
      `;
      }

      if (followUp.marketingTemplate) {
        followUp.marketingTemplate.defaultText = followUp.marketingTemplate.text;
        followUp.marketingTemplate.text = this.helperService.mktTemplateParser(parseData, followUp.marketingTemplate?.text);
      }

      if (order.isRecommended) {
        recommendedFollowUps.push(followUp);
      } else {
        eligibleFollowUps.push(followUp);
      }
    });

    return { recommendedFollowUps, eligibleFollowUps };
  }

  formatScheduledFollowUp(data: any[], customer: any, contact: any = {}) {
    const pastFollowUps = [];
    const upcomingFollowUps = [];
    const upcomingFollowUpIds = [];
    const primary: any = { email: {}, phone: {} };

    if (contact && contact.contactInfo && contact.contactInfo.length) {
      contact.contactInfo.forEach((contact: any) => {
        if (contact.isPrimary) {
          if (contact.contactType === 'email') {
            primary.email = contact;
          } else {
            primary.phone = contact;
          }
        }
      });
    }

    data.forEach(
      ({ _id, campaignId, title, status, createdAt, scheduleAt, stoppedActivity, followUpEvent, customer, vehicle, order, type, marketingTemplate, isSendToPrimaryOnly, isSend, sentToContacts }) => {
        let parseData: any = {};

        const followUp = {
          order: order || {},
          type,
          isSend,
          matchId: '',
          contact: '',
          sentTooltip: '',
          contactTooltip: '',
          customer: {},
          contacts: [],
          unsubscribeCount: 0,
          vehicle: null,
          followUpId: _id,
          templateType: type,
          campaignTitle: title,
          campaignStatus: status,
          campaignId: campaignId,
          marketingTemplate: marketingTemplate,
          isSendToPrimaryOnly: isSendToPrimaryOnly,
          stoppedActivity: stoppedActivity,
          createdAt: this.dateService.getCurrentDateTimeTz(new Date(createdAt).getTime()),
          scheduleAt: this.dateService.getCurrentDateTimeTz(new Date(scheduleAt).getTime()),
          deleteTooltip: `Stop follow-up`,
          resumeTooltip: `Subscribe customer from the upcoming "${title}"`,
          isAllSent: true,
          activities: [],
        };

        if (contact && contact.contactInfo && contact.contactInfo.length) {
          if (type === 'EMAIL') {
            if (isSendToPrimaryOnly && primary.email.value) {
              followUp.contacts = [primary.email.value];

              if (primary.email.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
            } else if (!isSendToPrimaryOnly) {
              contact.contactInfo.forEach((contact: any) => {
                if (contact.isActive && contact.contactType === 'email') {
                  followUp.contacts.push(contact.value);

                  if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
                }
              });
            }
          } else if (type === 'SMS') {
            if (isSendToPrimaryOnly && primary.phone.value) {
              followUp.contacts = [primary.phone.value];

              if (primary.phone.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
            } else if (!isSendToPrimaryOnly) {
              contact.contactInfo.forEach((contact: any) => {
                if (contact.isActive && ['mobile', 'landline'].includes(contact.contactType)) {
                  followUp.contacts.push(contact.value);

                  if (contact.isMarketingNotifEnabled === false) followUp.unsubscribeCount += 1;
                }
              });
            }
          }
        }

        if (customer) {
          followUp.customer = customer;
          parseData.customerCreatedAt = customer.createdAt ? this.dateService.getCurrentDateTimeTz(new Date(customer.createdAt).getTime()) : '';
          parseData.contact = type === 'EMAIL' ? customer.email : this.helperService.formatPhoneNumber(customer.phone);
          followUp.contact = parseData.contact;
        }

        if (vehicle && vehicle.vehicleId) {
          followUp.vehicle = { vehicleId: vehicle.vehicleId, name: vehicle.name };
        }

        if (sentToContacts && sentToContacts.length) {
          followUp.sentTooltip = `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
          ${type === 'EMAIL' ? 'Email' : 'SMS'}
          </div>

          ${(sentToContacts || [])
            .map(
              ({ isSent, contactType, value }) =>
                `<div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
                <i class="fal fa-${isSent ? 'check' : 'times'} ${isSent ? 'font-primary' : 'font-red'} mt-1 pr-2"></i>
                <span class="truncate" style="width: 160px;">${value}</span>
              </div>`,
            )
            .join('')}
        </div>
      `;

          if (isSend) {
            followUp.isAllSent = !sentToContacts.filter(({ isSent }) => !isSent).length;
          }
        }

        if (followUp.contacts && followUp.contacts.length) {
          followUp.contactTooltip = `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
          ${type === 'EMAIL' ? 'Email' : 'SMS'}
          </div>

          ${(followUp.contacts || [])
            .map(
              (contact: string) =>
                `<div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
                <i class="fal fa-${type === 'EMAIL' ? 'envelope' : 'mobile'} font-gray-65 mt-1"></i>
                <span class="truncate" style="width: 160px;">${contact}</span>
              </div>`,
            )
            .join('')}

            ${
              followUp.unsubscribeCount
                ? `<div class="tooltip-secondary-row font-12 font-orange py-0 mt-1">
                    <span>${followUp.unsubscribeCount} ${type === 'EMAIL' ? 'email' : 'phone'} opted out</span>
                  </div>`
                : ''
            }
        </div>
      `;
        }

        if (followUpEvent === followUpEvents.VEHICLE_SAVE) {
          followUp.vehicle = { vehicleId: vehicle.vehicleId, name: vehicle.name };
          parseData.vehicleCreatedAt = vehicle.createdAt ? this.dateService.getCurrentDateTimeTz(new Date(vehicle.createdAt).getTime()) : '';
          parseData.vehicleName = vehicle.name;
        }

        parseData = {
          ...parseData,
          ...followUp.order,
        };

        if (followUp.marketingTemplate) {
          followUp.marketingTemplate.text = this.helperService.mktTemplateParser(parseData, followUp.marketingTemplate?.text);
        }

        if (followUpEvent === followUpEvents.CUSTOMER_SAVE) {
          followUp.matchId = `${campaignId}-${customer && customer.customerId}`;
        } else if (followUpEvent === followUpEvents.VEHICLE_SAVE) {
          followUp.matchId = `${campaignId}-${vehicle && vehicle.vehicleId}`;
        } else {
          followUp.matchId = `${campaignId}-${order && order.orderId}`;
        }

        if (this.dataService.isAutomatedFollowUpEnabled) {
          if (this.dateService.getCurrentDateTimeTz(new Date(scheduleAt).getTime()) > this.dateService.getCurrentDateTimeTz(new Date().getTime())) {
            upcomingFollowUps.push(followUp);
            upcomingFollowUpIds.push(followUp.matchId);
          } else {
            pastFollowUps.push(followUp);
          }
        } else {
          if (isSend) {
            if (sentToContacts.length) {
              followUp.contacts = sentToContacts.map(({ value }) => value);
            } else {
              followUp.contacts = [];
            }

            pastFollowUps.push(followUp);
          } else {
            upcomingFollowUps.push(followUp);
            upcomingFollowUpIds.push(followUp.matchId);
          }
        }
      },
    );

    return { pastFollowUps: [...pastFollowUps], upcomingFollowUps: [...upcomingFollowUps], upcomingFollowUpIds: [...upcomingFollowUpIds] };
  }

  // format filters for discounts report
  formatDiscountReportFilter(filters: any) {
    const formattedFilters: any = {};
    const { date = {}, orderOn = {}, orderDiscountType = {}, shopIds = { shopIds: [] } } = filters;

    formattedFilters.startDate = date.startDate;
    formattedFilters.endDate = date.endDate;

    if (shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = '';
    }

    if (orderOn.orderLevel !== orderOn.serviceLevel) {
      formattedFilters.orderOn = orderOn.orderLevel ? 'order' : 'service';
    } else {
      formattedFilters.orderOn = '';
    }

    if (orderDiscountType.percentage !== orderDiscountType.dollarValue) {
      formattedFilters.orderDiscountType = orderDiscountType.percentage ? 'percentage' : 'value';
    } else {
      formattedFilters.orderDiscountType = '';
    }

    return formattedFilters;
  }

  // format filters for discount drilldown report
  formatDiscountDrillDownReportFilter(filters: any) {
    const formattedFilters: any = {};
    const { date = {}, orderDiscountType = {}, shopIds = { shopIds: [] } } = filters;

    formattedFilters.startDate = date.startDate;
    formattedFilters.endDate = date.endDate;

    if (shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = '';
    }

    if (orderDiscountType.percentage !== orderDiscountType.dollarValue) {
      formattedFilters.discountType = orderDiscountType.percentage ? 'percentage' : 'value';
    } else {
      formattedFilters.discountType = '';
    }

    return formattedFilters;
  }

  formatSupplierDrilldownFilter(filters: any) {
    // this.selectedFilter.suppliers = [];
    const formattedFilters: any = {};
    const { orderingMethods = {}, orderingStatus = {}, paymentTerms = {}, shopIds = [], date = {}, supplierType = {}, supplier = { selected: [] } } = filters;
    const { startDate, endDate } = date;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    formattedFilters.startDate = startDate;
    formattedFilters.endDate = endDate;

    if (orderingMethods) {
      formattedFilters.orderingMethods = [];
      Object.keys(orderingMethods).forEach((key) => {
        if (orderingMethods[key]) {
          formattedFilters.orderingMethods.push(this.orderingMethodsValue[key]);
        }
      });
    } else {
      formattedFilters.orderingMethods = [];
    }

    if (orderingStatus) {
      formattedFilters.orderingStatus = [];
      Object.keys(orderingStatus).forEach((key) => {
        if (orderingStatus[key]) {
          formattedFilters.orderingStatus.push(this.orderingStatusValue[key]);
        }
      });
    } else {
      formattedFilters.orderingStatus = [];
    }

    if (paymentTerms) {
      formattedFilters.paymentTerms = [];

      if (paymentTerms.payable) {
        formattedFilters.paymentTerms.push('PAYABLE');
      }

      if (paymentTerms.cod) {
        formattedFilters.paymentTerms.push('COD');
      }
    } else {
      formattedFilters.paymentTerms = [];
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = [];
    }

    if (supplier && supplier.selected && supplier.selected.length) {
      formattedFilters.name = supplier.selected.map(({ name }) => name);
    } else {
      formattedFilters.name = [];
    }

    if (supplierType.internal !== supplierType.online) {
      formattedFilters.type = supplierType.online ? 'online' : 'internal';
    } else {
      formattedFilters.type = 'all';
    }

    return formattedFilters;
  }

  formatSupplierFilter(filters: any) {
    const formattedFilters: any = {};
    const { orderingMethods = {}, orderingStatus = {}, paymentTerms = {}, shopIds = [], date = {}, supplierType = {}, supplier = { selected: [] } } = filters;
    const { startDate, endDate } = date;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    formattedFilters.startDate = startDate;
    formattedFilters.endDate = endDate;

    if (orderingMethods) {
      formattedFilters.orderingMethods = [];
      Object.keys(orderingMethods).forEach((key) => {
        if (orderingMethods[key]) {
          formattedFilters.orderingMethods.push(this.orderingMethodsValue[key]);
        }
      });
    } else {
      formattedFilters.orderingMethods = [];
    }

    if (orderingStatus) {
      formattedFilters.orderingStatus = [];
      Object.keys(orderingStatus).forEach((key) => {
        if (orderingStatus[key]) {
          formattedFilters.orderingStatus.push(this.orderingStatusValue[key]);
        }
      });
    } else {
      formattedFilters.orderingStatus = [];
    }

    if (paymentTerms) {
      formattedFilters.paymentTerms = [];

      if (paymentTerms.payable) {
        formattedFilters.paymentTerms.push('PAYABLE');
      }

      if (paymentTerms.cod) {
        formattedFilters.paymentTerms.push('COD');
      }
    } else {
      formattedFilters.paymentTerms = [];
    }

    if (isMultiLocationEnabled && shopIds && shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = [];
    }

    if (supplier && supplier.selected && supplier.selected.length) {
      formattedFilters.name = supplier.selected.map(({ name }) => name);
    } else {
      formattedFilters.name = [];
    }

    if (supplierType.internal !== supplierType.online) {
      formattedFilters.type = supplierType.online ? 'online' : 'internal';
    } else {
      //formattedFilters.type = 'all';
      const { genericFilter } = filters;
      const supplierTypes = genericFilter?.selected || [];
      formattedFilters.type = supplierTypes.map((type: any) => encodeURIComponent(type?.value));
    }

    return formattedFilters;
  }

  // format filters for discount drilldown report
  formatUnusedPartFilter(filters: any, viewType: string = 'report') {
    const formattedFilters: any = {};
    const { startDate, endDate, shopIds = [], date = {}, orderStatus = {}, genericFilter = {}, itemType = {}, roStatus = '', itemTypes = [] } = filters;

    // Item type
    if (viewType === 'report') {
      // From report filter
      if (itemType && itemType.part !== itemType.tire) {
        formattedFilters.type = itemType.part ? 'part' : 'tire';
      } else {
        formattedFilters.type = null;
      }
    } else {
      // From order filter
      if (itemTypes && itemTypes.length) {
        formattedFilters.type = itemTypes.length === 1 ? itemTypes[0] : null;
      } else {
        formattedFilters.type = null;
      }
    }

    // Order status
    if (viewType === 'report') {
      // From report filter
      if (orderStatus && orderStatus.estimate !== orderStatus.invoice) {
        formattedFilters.orderStatus = orderStatus.estimate ? 'estimate' : 'invoice';
      } else {
        formattedFilters.orderStatus = null;
      }
    } else {
      // From order filter
      if (roStatus) {
        formattedFilters.orderStatus = roStatus;
      } else {
        formattedFilters.orderStatus = null;
      }
    }

    // Ordered date
    if (viewType === 'report') {
      // From report filter
      if (date.startDate && date.endDate) {
        formattedFilters.startDate = date.startDate;
        formattedFilters.endDate = date.endDate;
      }
    } else {
      // From order filter
      if (startDate && endDate) {
        formattedFilters.startDate = startDate;
        formattedFilters.endDate = endDate;
      }
    }

    if (shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = [];
    }

    if (genericFilter && genericFilter.selected && genericFilter.selected.length > 0) {
      formattedFilters.itemSource = genericFilter.selected.map((item: any) => item.value);
    } else {
      formattedFilters.itemSource = [];
    }

    return formattedFilters;
  }

  // format filters for tax item report drilldown report
  formatTaxItemReportFilter(filters: any, baseTax: boolean) {
    const formattedFilters: any = {};
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const { shopIds = [], date = {}, paidStatus = {}, taxCode = {} } = filters;

    if (isMultiLocationEnabled && shopIds.length > 0) {
      formattedFilters.shopIds = shopIds;
    } else {
      formattedFilters.shopIds = [];
    }

    if (paidStatus) {
      const { paid = false, partiallyPaid = false, unPaid = false } = paidStatus;

      if (Array.from(new Set([paid, partiallyPaid, unPaid])).length > 1) {
        formattedFilters.paidStatus = { paid, partiallyPaid, unPaid };
      }
    } else {
      delete formattedFilters.paidStatus;
    }

    if (taxCode && taxCode._id) {
      formattedFilters.taxCode = taxCode._id;
    } else {
      delete formattedFilters.taxCode;
    }

    if (!baseTax) {
      formattedFilters.paymentDateStart = date.startDate;
      formattedFilters.paymentDateEnd = date.endDate;
      delete formattedFilters.invoiceDateStart;
      delete formattedFilters.invoiceDateEnd;
    } else if (baseTax) {
      delete formattedFilters.paymentDateStart;
      delete formattedFilters.paymentDateEnd;

      formattedFilters.invoiceDateStart = date.startDate;
      formattedFilters.invoiceDateEnd = date.endDate;
    }

    return formattedFilters;
  }

  mergeCustomer(customer) {
    const data = {
      'Customer type': customer.isFleetCustomer ? 'Fleet' : 'Regular',
      Name: customer.fullNameQBO,
      'Phone (Primary)': this.helperService.formatPhoneNumber(customer.phone),
      'Email (Primary)': customer.email,
      Address: customer.address.addLine1 ? customer.address.addLine1 : customer.address.addLine2,
      'No of Vehicles': customer.vehicles.length,
      'No of ROs': (customer.extraDetails && customer.extraDetails.orders) || 0,
      'No of Appointment': (customer.extraDetails && customer.extraDetails.appointments) || 0,
      'No of follow-ups': (customer.extraDetails && customer.extraDetails.scheduledFollowUps) || 0,
      'No of marketing groups': (customer.extraDetails && customer.extraDetails.marketingGroup) || 0,
    };
    return data;
  }
  /*
  Here we mapping customer approval service status on customer pdf preview
  */
  formatTechDetailsAndAuthorizationPrintPreview(service, timezone: string) {
    service.approveConfirmation = service.serviceAuthHistory.reverse().find(({ status }) => status !== serviceAuthConsts.declined);
    if (service.approveConfirmation) {
      const updatedTime = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(service.approveConfirmation.createdAt).getTime(), timezone), datetimeFormat.listDT);
      service.approveConfirmation.createdAt = updatedTime;

      if (service.approveConfirmation.method) {
        service.approveConfirmation.method = service.approveConfirmation.method === 'inPerson' ? '(In person)' : `(${service.approveConfirmation.method})`;
      }
    }

    const technicians = [service.tech, service.hTechOne, service.hTechTwo];
    const techDetails = [];
    technicians.map((technician) => {
      if (technician && technician.name) {
        let tech = '';
        tech = `${technician.name} ${technician.registrationNumber ? `(Reg no.${technician.registrationNumber})` : ''}`;
        techDetails.push(tech);
      }
    });
    if (techDetails && techDetails.length > 0) {
      service.techDetails = techDetails.join(', ');
    }
    return service;
  }

  formatCustomerCreditMemo(memo: any[]) {
    return memo.map(({ _id, code, amount, remainingAmount, isFullApplied, isPartialApplied, linkedEstimate, qboReference }) => ({
      code: code,
      _id,
      status: isFullApplied ? 'Applied' : isPartialApplied ? 'Partially applied' : 'Unapplied',
      amount: amount || 0,
      remainingAmount: remainingAmount || 0,
      appliedAmount: 0,
      invCode: linkedEstimate && linkedEstimate.code,
      qboSyncStatus: qboReference && qboReference.isSyncedWithQBO,
    }));
  }
  maskCardNumber(cardNumber: string, completeMask = false): string {
    const visiblePart = cardNumber.slice(-4);
    if (completeMask) {
      return '**** **** ****' + visiblePart;
    }
    return '*' + visiblePart;
  }

  formatGlobalPaymentTransactionDetails(rsp) {
    if (rsp.isVoidPayment) {
      const tenderType = 'credit';

      const transaction = rsp.transactions[0];
      const cardDetails = transaction[`${tenderType}_attributes`];

      return {
        payment: {
          amount: rsp.amount,
          type: transaction.tender_type,
          card4Digits: this.maskCardNumber(cardDetails?.card?.masked_card_number),
          card4DigitsFullMask: this.maskCardNumber(cardDetails?.card?.masked_card_number, true),
          cardType: cardDetails?.card?.type,
          code: rsp.invoice_number || '-',
          paymentDate: rsp.paymentDate,
          globalPayResponse: {
            approval_code: cardDetails?.approval_code,
            creditId: rsp.isRefund ? transaction?.id : transaction?.id,
            status: transaction?.status,
          },
        },
      };
    } else {
      const tenderType = rsp.isCredit ? 'card' : 'debit_card';
      return {
        payment: {
          amount: rsp.payment.amount,
          type: rsp.payment.type,
          card4Digits: this.maskCardNumber(rsp[`${tenderType}`]?.masked_card_number),
          card4DigitsFullMask: this.maskCardNumber(rsp[`${tenderType}`]?.masked_card_number, true),
          cardType: rsp[`${tenderType}`]?.type,
          code: rsp.payment.invoice_number || '-',
          paymentDate: rsp.paymentDate,
          globalPayResponse: {
            approval_code: rsp?.approval_code,
            creditId: rsp.isRefund ? (rsp.isCredit ? rsp?.creditreturn_id : rsp.debitreturn_id) : rsp.isCredit ? rsp.creditsale_id : rsp.debitsale_id,
            status: rsp?.status,
          },
        },
      };
    }
  }

  formatPaymentsHistory(payments: any[], isOnlinePaymentEnable: boolean) {
    let totalRefunds = 0;
    let paymentsHistory = [];

    if (history?.length) {
      paymentsHistory = payments.map((payment: any) => {
        if (!!payment.paymentDate) {
          payment.createdAt = new Date(payment.paymentDate);
        } else {
          payment.createdAt = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
        }

        // Need this flag in tooltip
        payment.isOnlinePaymentFeatureEnable = isOnlinePaymentEnable;
        payment.tooltip = this.helperService.createPaymentLogTooltip(payment);
        totalRefunds += this.calculationService.roundOff(payment.refundToDate);

        payment.refunds.map((refund: any) => {
          refund.tooltip = this.helperService.createRefundTooltip(refund, payment);
          refund.refundDate = this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime());
          refund.isVoidPayment = refund.isVoid;
          return refund;
        });

        // sort refunds
        payment.refunds = orderBy(payment.refunds, ['refundDate'], 'desc');

        if (payment.isCreditPayment) {
          payment.paymentHistory.map((credit) => {
            payment.creditMethodType = credit.paymentMethod.replace('Memo', 'payment');
          });
        }

        return payment;
      });
    }

    return { paymentsHistory, totalRefunds };
  }

  formateAPMovement(records) {
    records.forEach((element) => {
      try {
        if (element.itemType) {
          element.stocked = element.itemType.match(/\((.*?)\)/g)?.map((match) => match.slice(1, -1));
          if (element.stocked[0].includes('non')) {
            element.stocked = 'No';
          } else {
            element.stocked = 'Yes';
          }
        }

        if ([true, false].includes(element.isExportedToReturn)) {
          element.isExportedToReturn = element.isExportedToReturn ? 'Yes' : 'No';
        }
        if ([true, false].includes(element.isExportedToAP)) {
          element.isExportedToReturn = element.isExportedToAP ? 'Yes' : 'No';
        }
      } catch (err) {
        console.log(err);
      }
      if (element.creditNo) {
        element.creditNumber = element.creditNo;
      }
      element.transactionDate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.transactionDate).getTime()), datetimeFormat.mmmdyyyy);
      element.finalizeDate = element.finalizeDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.finalizeDate).getTime()), datetimeFormat.mmmdyyyy) : '';
      element.deliveryDate = element.deliveryDate ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(element.deliveryDate).getTime()), datetimeFormat.mmmdyyyy) : '';

      element['tax'] = element.taxValue || element.tax || 0;
    });
    return records;
  }

  formateRoyaltyReportStats(records) {
    const additionaSatas = records.additionalStats;
    const royaltyPayment = records.royaltyPayment;

    let kpis: any = {
      totalEmployeeVehicles: additionaSatas?.totalEmployeeVehicles?.total || 0,
      totalFleetVehicles: additionaSatas?.totalFleetVehicles?.total || 0,
      totalROs: additionaSatas?.totalROs?.total || 0,
      totalVehicles: additionaSatas?.totalVehicles?.total || 0,

      customRoyaltyFee: royaltyPayment?.customRoyaltyFee?.sort((a, b) => a.royaltyFee - b.royaltyFee) || [],
      totalCustomRoyaltyFee: this.sumOfAll(royaltyPayment.customRoyaltyFee, 'total'),

      totalShopSale: royaltyPayment?.totalShopSale?.total || 0,
      customRoyaltySales: royaltyPayment?.customRoyaltySales || [],
      totalCustomRoyaltySales: this.sumOfAll(royaltyPayment.customRoyaltySales, 'total'),

      royaltyTaxes: royaltyPayment?.royaltyTaxes || [],
      totalRoyaltyTaxes: this.sumOfAll(royaltyPayment?.royaltyTaxes, 'total'),

      standardRoyaltyFee: royaltyPayment?.standardRoyaltyFee,
      standardRoyaltySale: royaltyPayment?.standardRoyaltySale,

      totalEmployeeSaleAdjustment: records?.totalEmployeeSaleAdjustment,
      totalNationalFleetSalAdjustment: records?.totalNationalFleetSalAdjustment,
    };
    // royaltyFeeStats?.totalShopSale - royaltyFeeStats?.totalCustomRoyaltySales
    kpis.totalRoyaltyPaymentDue = kpis?.standardRoyaltyFee?.total + kpis?.totalCustomRoyaltyFee - kpis?.totalEmployeeSaleAdjustment - kpis?.totalNationalFleetSalAdjustment;
    kpis.totalAmountDue = kpis?.totalRoyaltyPaymentDue + kpis?.totalRoyaltyTaxes;
    return kpis;
  }

  sumOfAll(array, key) {
    if (array?.length) {
      return array.reduce((accumulator, current) => accumulator + current[key], 0);
    } else {
      return 0;
    }
  }

  formatRoyaltyReport(records: any[], extras: any, removeCurrencySign = false) {
    // const royaltyReportTotalSales = this.sumOfAll(records, 'totalSales');

    const totalRoyaltyFeeExtra = extras[0].totalRoyaltyFee;
    const totalShopSales = extras[0].totalShopSales;
    return records.map(
      ({
        employeeSales,
        groupCode,
        laborSales,
        m2GroupCode,
        m2GroupName,
        name,
        nationalFleetSales,
        noOfJobs,
        noOfOperations,
        partSales = 0,
        salesCodes,
        tirStorageSales = 0,
        FeeSales = 0,
        tiresSales = 0,
        totalSales,
        salesMix,
        totalRoyaltyFee,
        othersSales = 0,
        subletSales = 0,
      }) => ({
        employeeSales: removeCurrencySign ? this.calculationService.roundOff(employeeSales || 0) : this.formatCurrency(employeeSales || 0),
        groupName: name || '',
        groupCode: groupCode || '',
        m2GroupName: m2GroupName || '',
        laborSales: removeCurrencySign
          ? this.calculationService.roundOff(othersSales + subletSales + laborSales + tirStorageSales || 0)
          : this.formatCurrency(othersSales + subletSales + laborSales + tirStorageSales || 0),
        m2GroupCode: m2GroupCode || 'N/A',
        totalSales: removeCurrencySign ? this.calculationService.roundOff(totalSales || 0) : this.formatCurrency(totalSales || 0),
        nationalFleetSales: removeCurrencySign ? this.calculationService.roundOff(nationalFleetSales || 0) : this.formatCurrency(nationalFleetSales || 0),
        noOfOperations: noOfOperations || 0,
        partSales: removeCurrencySign ? this.calculationService.roundOff(partSales + tiresSales + FeeSales || 0) : this.formatCurrency(partSales + tiresSales + FeeSales || 0),
        salesCodes: this.formateSalesCode(salesCodes, removeCurrencySign),
        tirStorageSales: removeCurrencySign ? this.calculationService.roundOff(tirStorageSales || 0) : this.formatCurrency(tirStorageSales || 0),
        FeeSales: removeCurrencySign ? this.calculationService.roundOff(FeeSales || 0) : this.formatCurrency(FeeSales || 0),
        tiresSales: removeCurrencySign ? this.calculationService.roundOff(tiresSales || 0) : this.formatCurrency(tiresSales || 0),
        salesMix: `${this.calculationService.roundOff((totalSales / totalShopSales || 0) * 100)}${!removeCurrencySign ? '%' : ''}`,
        totalRoyaltyFee: `${this.calculationService.roundOff((totalRoyaltyFee / totalRoyaltyFeeExtra || 0) * 100)}${!removeCurrencySign ? '%' : ''}`,
        noOfJobs: noOfJobs || 0,
      }),
    );
  }

  formateSalesCode(data, removeCurrencySign = false) {
    return data.map((data, i) => {
      const { employeeSales, othersSales, subletSales, laborSales, noOfJobs, totalSales, nationalFleetSales, noOfOperations, partsSales, tirStorageSales, FeeSales, tiresSales } = data.kpis;
      return {
        index: i,
        employeeSales: removeCurrencySign ? employeeSales?.total || 0 : this.formatCurrency(employeeSales?.total || 0),
        groupName: data.title || '',
        groupCode: data?.shortName || '',
        laborSales: removeCurrencySign
          ? this.calculationService.roundOff((laborSales?.total || 0) + (tirStorageSales?.total || 0) + (othersSales?.total || 0) + (subletSales?.total || 0))
          : this.formatCurrency((laborSales?.total || 0) + (tirStorageSales?.total || 0) + (othersSales?.total || 0) + (subletSales?.total || 0)),
        totalSales: removeCurrencySign ? this.calculationService.roundOff(totalSales?.total || 0) : this.formatCurrency(totalSales?.total || 0),
        nationalFleetSales: removeCurrencySign ? this.calculationService.roundOff(nationalFleetSales?.total || 0) : this.formatCurrency(nationalFleetSales?.total || 0),
        noOfOperations: noOfOperations?.total || 0,
        partSales: removeCurrencySign
          ? this.calculationService.roundOff((partsSales?.total || 0) + (tiresSales?.total || 0) + (FeeSales?.total || 0)) || 0
          : this.formatCurrency((partsSales?.total || 0) + (tiresSales?.total || 0) + (FeeSales?.total || 0) || 0),
        tirStorageSales: removeCurrencySign ? this.calculationService.roundOff(tirStorageSales?.total || 0) : this.formatCurrency(tirStorageSales?.total || 0),
        FeeSales: removeCurrencySign ? this.calculationService.roundOff(FeeSales?.total || 0) : this.formatCurrency(FeeSales?.total || 0),
        tiresSales: removeCurrencySign ? this.calculationService.roundOff(tiresSales?.total || 0) : this.formatCurrency(tiresSales?.total || 0),
        // salesMix: `${this.calculationService.roundOff(data?.salesMix || 0)}%`,
        noOfJobs: '',
      };
    });
  }

  formatCatalogPriceMatrix(records: any[]) {
    return records.map(
      ({
        isSelected,
        name,
        totalAmount,
        costValue,
        flatRate,
        currentPrice,
        itemCount,
        title,
        shopDetails,
        code,
        category,
        supplier,
        cost,
        price,
        _id,
        updatedPrice,
        brand,
        model,
        size,
        part,
        vendor,
      }) => ({
        itemName: title || name,
        code,
        categoryName: category?.name || '',
        supplierNum: supplier?.name || '',
        cost: costValue || cost,
        price: (shopDetails && shopDetails?.price) || currentPrice || price,
        updatedPrice: (shopDetails && shopDetails?.updatedPrice) || updatedPrice,
        _id,
        brand,
        model,
        size,
        part,
        vendor,
        totalAmount,
        flatRate,
        itemCount,
        isSelected: (shopDetails && shopDetails?.isSelected) || isSelected,
      }),
    );
  }
}
